const omsDetails = [{
    "url": "https:\/\/forms.shopifyapps.com\/",
}];
const header = {}

// 存储上传后的图片信息
let uploadedImagesData = {
    petImages: [], // 存储宠物图片信息 [{image: 'url', remark: 'description'}, ...]
    furColorImage: null, // 毛色图片URL
    furLengthImage: null, // 毛长图片URL
    petAgeImage: null // 年龄图片URL
};

const container = document.getElementById("productOptionsContainer");

// 检测是否需要隐藏Frame Options（只在product.type为空且跳转到customizer页面时）
function isFromPlushClonesCollection() {

    // 检查当前 URL 参数中是否有 variant 参数（表示是通过customizer页面跳转来的）
    const urlParams = new URLSearchParams(window.location.search);
    const variant = urlParams.get('variant');

    if (!variant) {
        return false;
    }

    // 检查 sessionStorage 中的 customizerFormData
    const storedDataString = sessionStorage.getItem('customizerFormData');
    if (storedDataString) {
        try {
            const retrievedFormData = JSON.parse(storedDataString);

            // 检查是否有product type信息，且为空或空字符串
            const productType = retrievedFormData.productType || retrievedFormData['product-type'];

            if (!productType || productType.trim() === '') {
                return true;
            } else {
                return false;
            }
        } catch (e) {
            return false;
        }
    }

    return false;
}

// 隐藏 Frame Options 的函数（只隐藏Frame Options，保留Background Options）
function hideFrameOptions() {
    const frameContainer = document.querySelector('.frame-container');

    if (frameContainer) {
        frameContainer.style.display = 'none';
    }
}

// 语言检测和翻译功能
function getCurrentLanguage() {
    var pathSegments = window.location.pathname.split('/').filter(function (x) { return x; });
    // 检查第一个路径段是否是语言代码（如 zh-cn, en 等）
    if (pathSegments.length > 0) {
        var firstSegment = pathSegments[0].toLowerCase();
        // 常见的语言代码格式：zh-cn, en, fr, de 等
        if (firstSegment.match(/^[a-z]{2}(-[a-z]{2})?$/)) {
            return firstSegment;
        }
    }
    return 'en'; // 默认返回英文
}

// 翻译函数 - 根据当前语言获取品种名称的翻译
function translateBreedName(breedDescription) {
    const currentLang = getCurrentLanguage();

    // 如果是中文环境，尝试获取翻译
    if (currentLang === 'zh-cn') {
        // 将品种描述转换为翻译键格式
        const translationKey = 'customizer.breed_' + breedDescription.toLowerCase().replace(/[^a-z0-9]/g, '_');

        // 这里我们需要从页面中获取翻译数据
        // 由于 Shopify 的翻译系统，我们可以通过创建隐藏元素来获取翻译
        const tempElement = document.createElement('div');
        tempElement.style.display = 'none';
        tempElement.setAttribute('data-translation-key', translationKey);
        document.body.appendChild(tempElement);

        // 尝试获取翻译，如果没有翻译则返回原文
        try {
            // 这里使用一个简化的翻译映射，实际项目中可以通过其他方式获取
            const translations = getBreedTranslations();
            const translated = translations[translationKey];
            document.body.removeChild(tempElement);
            return translated || breedDescription;
        } catch (e) {
            document.body.removeChild(tempElement);
            return breedDescription;
        }
    }

    return breedDescription; // 英文或其他语言直接返回原文
}

// 品种翻译映射表（完整版本）
function getBreedTranslations() {
    return {
        // 狗的品种翻译
        'customizer.breed_affenpinscher': '猴面犬',
        'customizer.breed_afghan_hound': '阿富汗猎犬',
        'customizer.breed_airedale_terrier': '万能梗',
        'customizer.breed_akbash': '阿卡巴什犬',
        'customizer.breed_akita': '秋田犬',
        'customizer.breed_alaskan_malamute': '阿拉斯加雪橇犬',
        'customizer.breed_american_bulldog': '美国斗牛犬',
        'customizer.breed_american_eskimo_dog': '美国爱斯基摩犬',
        'customizer.breed_american_foxhound': '美国猎狐犬',
        'customizer.breed_american_pit_bull_terrier': '美国比特犬',
        'customizer.breed_american_staffordshire_terrier': '美国斯塔福德梗',
        'customizer.breed_american_water_spaniel': '美国水猎犬',
        'customizer.breed_anatolian_shepherd_dog': '安纳托利亚牧羊犬',
        'customizer.breed_australian_cattle_dog': '澳大利亚牧牛犬',
        'customizer.breed_australian_kelpie': '澳大利亚凯尔派犬',
        'customizer.breed_australian_shepherd': '澳大利亚牧羊犬',
        'customizer.breed_australian_terrier': '澳大利亚梗',
        'customizer.breed_basenji': '巴辛吉犬',
        'customizer.breed_basset_hound': '巴塞特猎犬',
        'customizer.breed_beagle': '比格犬',
        'customizer.breed_bearded_collie': '古代长须牧羊犬',
        'customizer.breed_beauceron': '波斯伦犬',
        'customizer.breed_bedlington_terrier': '贝德灵顿梗',
        'customizer.breed_belgian_malinois': '比利时马林诺斯犬',
        'customizer.breed_belgian_sheepdog': '比利时牧羊犬',
        'customizer.breed_belgian_tervuren': '比利时特弗伦犬',
        'customizer.breed_bernese_mountain_dog': '伯恩山犬',
        'customizer.breed_bichon_frise': '比熊犬',
        'customizer.breed_black_and_tan_coonhound': '黑褐色浣熊猎犬',
        'customizer.breed_black_russian_terrier': '黑俄罗斯梗',
        'customizer.breed_bloodhound': '寻血猎犬',
        'customizer.breed_bluetick_coonhound': '蓝色斑点浣熊猎犬',
        'customizer.breed_boerboel': '南非獒',
        'customizer.breed_border_collie': '边境牧羊犬',
        'customizer.breed_border_terrier': '边境梗',
        'customizer.breed_borzoi': '俄罗斯猎狼犬',
        'customizer.breed_boston_terrier': '波士顿梗',
        'customizer.breed_bouvier_des_flandres': '法兰德斯牧牛犬',
        'customizer.breed_boxer': '拳师犬',
        'customizer.breed_boykin_spaniel': '博伊金猎犬',
        'customizer.breed_briard': '布里犬',
        'customizer.breed_brittany': '布列塔尼犬',
        'customizer.breed_brussels_griffon': '布鲁塞尔格里芬犬',
        'customizer.breed_bull_terrier': '牛头梗',
        'customizer.breed_bulldog': '斗牛犬',
        'customizer.breed_bullmastiff': '斗牛獒',
        'customizer.breed_cairn_terrier': '凯恩梗',
        'customizer.breed_canaan_dog': '迦南犬',
        'customizer.breed_cane_corso': '卡斯罗犬',
        'customizer.breed_cardigan_welsh_corgi': '卡迪根威尔士柯基犬',
        'customizer.breed_catahoula_leopard_dog': '卡塔胡拉豹犬',
        'customizer.breed_cavalier_king_charles_spaniel': '骑士查理王小猎犬',
        'customizer.breed_chesapeake_bay_retriever': '切萨皮克湾寻回犬',
        'customizer.breed_chihuahua': '吉娃娃',
        'customizer.breed_chinese_crested': '中国冠毛犬',
        'customizer.breed_chinese_shar_pei': '中国沙皮犬',
        'customizer.breed_chow_chow': '松狮犬',
        'customizer.breed_clumber_spaniel': '克伦伯猎犬',
        'customizer.breed_cocker_spaniel': '可卡犬',
        'customizer.breed_collie': '牧羊犬',
        'customizer.breed_coonhound': '浣熊猎犬',
        'customizer.breed_corgi': '柯基犬',
        'customizer.breed_coton_de_tulear': '图莱亚尔棉花犬',
        'customizer.breed_curly_coated_retriever': '卷毛寻回犬',
        'customizer.breed_dachshund': '腊肠犬',
        'customizer.breed_dalmatian': '大麦町犬',
        'customizer.breed_dandie_dinmont_terrier': '丹迪丁蒙梗',
        'customizer.breed_doberman_pinscher': '杜宾犬',
        'customizer.breed_dogue_de_bordeaux': '波尔多犬',
        'customizer.breed_english_bulldog': '英国斗牛犬',
        'customizer.breed_english_cocker_spaniel': '英国可卡犬',
        'customizer.breed_english_foxhound': '英国猎狐犬',
        'customizer.breed_english_setter': '英国塞特犬',
        'customizer.breed_english_springer_spaniel': '英国史宾格犬',
        'customizer.breed_english_toy_spaniel': '英国玩具猎犬',
        'customizer.breed_entlebucher_mountain_dog': '恩特雷布赫山地犬',
        'customizer.breed_field_spaniel': '田野猎犬',
        'customizer.breed_finnish_lapphund': '芬兰拉普猎犬',
        'customizer.breed_finnish_spitz': '芬兰狐狸犬',
        'customizer.breed_flat_coated_retriever': '平毛寻回犬',
        'customizer.breed_fox_terrier': '猎狐梗',
        'customizer.breed_french_bulldog': '法国斗牛犬',
        'customizer.breed_german_pinscher': '德国宾莎犬',
        'customizer.breed_german_shepherd': '德国牧羊犬',
        'customizer.breed_german_shorthaired_pointer': '德国短毛指示犬',
        'customizer.breed_german_wirehaired_pointer': '德国硬毛指示犬',
        'customizer.breed_giant_schnauzer': '巨型雪纳瑞',
        'customizer.breed_glen_of_imaal_terrier': '爱尔兰峡谷梗',
        'customizer.breed_golden_retriever': '金毛寻回犬',
        'customizer.breed_goldendoodle': '金毛贵宾犬',
        'customizer.breed_gordon_setter': '戈登塞特犬',
        'customizer.breed_great_dane': '大丹犬',
        'customizer.breed_great_pyrenees': '大白熊犬',
        'customizer.breed_greater_swiss_mountain_dog': '大瑞士山地犬',
        'customizer.breed_greyhound': '灵缇犬',
        'customizer.breed_harrier': '哈利犬',
        'customizer.breed_havanese': '哈瓦那犬',
        'customizer.breed_ibizan_hound': '伊比赞猎犬',
        'customizer.breed_icelandic_sheepdog': '冰岛牧羊犬',
        'customizer.breed_irish_red_and_white_setter': '爱尔兰红白塞特犬',
        'customizer.breed_irish_setter': '爱尔兰塞特犬',
        'customizer.breed_irish_terrier': '爱尔兰梗',
        'customizer.breed_irish_water_spaniel': '爱尔兰水猎犬',
        'customizer.breed_irish_wolfhound': '爱尔兰猎狼犬',
        'customizer.breed_italian_greyhound': '意大利灵缇犬',
        'customizer.breed_jack_russell_terrier': '杰克罗素梗',
        'customizer.breed_japanese_chin': '日本狆',
        'customizer.breed_kai_ken': '甲斐犬',
        'customizer.breed_kangal': '坎高犬',
        'customizer.breed_keeshonden': '荷兰毛狮犬',
        'customizer.breed_kerry_blue_terrier': '凯利蓝梗',
        'customizer.breed_komondorok': '可蒙犬',
        'customizer.breed_kooikerhondje': '荷兰小狮子犬',
        'customizer.breed_kuvaszok': '库瓦兹犬',
        'customizer.breed_labradoodle': '拉布拉多贵宾犬',
        'customizer.breed_labrador_retriever': '拉布拉多寻回犬',
        'customizer.breed_lagotto_romagnolo': '拉戈托罗马阁挪露犬',
        'customizer.breed_lakeland_terrier': '湖畔梗',
        'customizer.breed_leonberger': '莱昂贝格犬',
        'customizer.breed_lhasa_apso': '拉萨犬',
        'customizer.breed_lowchen': '小狮子犬',
        'customizer.breed_mal_shi': '马尔济斯西施犬',
        'customizer.breed_maltese': '马尔济斯犬',
        'customizer.breed_maltipoo': '马尔济斯贵宾犬',
        'customizer.breed_manchester_terrier': '曼彻斯特梗',
        'customizer.breed_mastiff': '獒犬',
        'customizer.breed_miniature_bull_terrier': '迷你牛头梗',
        'customizer.breed_miniature_pinscher': '迷你杜宾犬',
        'customizer.breed_miniature_schnauzer': '迷你雪纳瑞',
        'customizer.breed_morkie': '约克夏马尔济斯犬',
        'customizer.breed_mountain_cur': '山地杂种犬',
        'customizer.breed_münsterländer': '明斯特兰德犬',
        'customizer.breed_neapolitan_mastiff': '那不勒斯獒',
        'customizer.breed_newfoundland': '纽芬兰犬',
        'customizer.breed_norfolk_terrier': '诺福克梗',
        'customizer.breed_norwegian_buhund': '挪威布哈德犬',
        'customizer.breed_norwegian_elkhound': '挪威猎麋犬',
        'customizer.breed_norwegian_lundehund': '挪威海鹦犬',
        'customizer.breed_norwich_terrier': '诺维奇梗',
        'customizer.breed_nova_scotia_duck_tolling_retriever': '新斯科舍诱鸭寻回犬',
        'customizer.breed_old_english_sheepdog': '古代英国牧羊犬',
        'customizer.breed_otterhound': '奥达猎犬',
        'customizer.breed_papillon': '蝴蝶犬',
        'customizer.breed_parson_russell_terrier': '帕森罗素梗',
        'customizer.breed_patterdale_terrier': '帕特代尔梗',
        'customizer.breed_pekeapoo': '北京犬贵宾犬',
        'customizer.breed_pekingese': '北京犬',
        'customizer.breed_pembroke_welsh_corgi': '彭布罗克威尔士柯基犬',
        'customizer.breed_petit_basset_griffon_vendeen': '小巴塞特格里芬旺代犬',
        'customizer.breed_pharaoh_hound': '法老王猎犬',
        'customizer.breed_pit_bull': '比特犬',
        'customizer.breed_plott': '普洛特猎犬',
        'customizer.breed_pointer': '指示犬',
        'customizer.breed_polish_lowland_sheepdog': '波兰低地牧羊犬',
        'customizer.breed_pomchi': '博美吉娃娃',
        'customizer.breed_pomeranian': '博美犬',
        'customizer.breed_poodle': '贵宾犬',
        'customizer.breed_portuguese_water_dog': '葡萄牙水犬',
        'customizer.breed_presa_canario': '加纳利犬',
        'customizer.breed_pug': '巴哥犬',
        'customizer.breed_puggle': '巴哥比格犬',
        'customizer.breed_pulik': '波利犬',
        'customizer.breed_pyrenean_shepherd': '比利牛斯牧羊犬',
        'customizer.breed_rat_terrier': '鼠梗',
        'customizer.breed_redbone_coonhound': '红骨浣熊猎犬',
        'customizer.breed_rhodesian_ridgeback': '罗得西亚脊背犬',
        'customizer.breed_rottweiler': '罗威纳犬',
        'customizer.breed_saint_bernard': '圣伯纳犬',
        'customizer.breed_saluki': '萨路基犬',
        'customizer.breed_samoyed': '萨摩耶犬',
        'customizer.breed_schapendoes': '荷兰牧羊犬',
        'customizer.breed_schipperke': '舒柏奇犬',
        'customizer.breed_schnoodle': '雪纳瑞贵宾犬',
        'customizer.breed_scottish_deerhound': '苏格兰猎鹿犬',
        'customizer.breed_scottish_terrier': '苏格兰梗',
        'customizer.breed_sealyham_terrier': '西里汉梗',
        'customizer.breed_shetland_sheepdog': '设得兰牧羊犬',
        'customizer.breed_shiba_inu': '柴犬',
        'customizer.breed_shichi': '西施吉娃娃',
        'customizer.breed_shih_tzu': '西施犬',
        'customizer.breed_shih_poo': '西施贵宾犬',
        'customizer.breed_siberian_husky': '西伯利亚哈士奇',
        'customizer.breed_silky_terrier': '丝毛梗',
        'customizer.breed_skye_terrier': '斯凯梗',
        'customizer.breed_smooth_collie': '短毛牧羊犬',
        'customizer.breed_smooth_fox_terrier': '短毛猎狐梗',
        'customizer.breed_soft_coated_wheaten_terrier': '软毛麦色梗',
        'customizer.breed_spanish_water_dog': '西班牙水犬',
        'customizer.breed_spinoni_italiani': '意大利史宾诺犬',
        'customizer.breed_staffordshire_bull_terrier': '斯塔福德郡斗牛梗',
        'customizer.breed_standard_schnauzer': '标准雪纳瑞',
        'customizer.breed_sussex_spaniel': '萨塞克斯猎犬',
        'customizer.breed_swedish_vallhund': '瑞典瓦汉德犬',
        'customizer.breed_tervuren': '特弗伦犬',
        'customizer.breed_texas_heeler': '德克萨斯牧牛犬',
        'customizer.breed_tibetan_mastiff': '藏獒',
        'customizer.breed_tibetan_spaniel': '西藏猎犬',
        'customizer.breed_tibetan_terrier': '西藏梗',
        'customizer.breed_toy_fox_terrier': '玩具猎狐梗',
        'customizer.breed_vizsla': '维兹拉犬',
        'customizer.breed_weimaraner': '威玛犬',
        'customizer.breed_welsh_springer_spaniel': '威尔士史宾格犬',
        'customizer.breed_welsh_terrier': '威尔士梗',
        'customizer.breed_west_highland_white_terrier': '西高地白梗',
        'customizer.breed_whippet': '惠比特犬',
        'customizer.breed_wire_fox_terrier': '硬毛猎狐梗',
        'customizer.breed_wirehaired_pointing_griffon': '硬毛指示格里芬犬',
        'customizer.breed_xoloitzcuintli': '墨西哥无毛犬',
        'customizer.breed_yorkipoo': '约克夏贵宾犬',
        'customizer.breed_yorkshire_terrier': '约克夏梗',
        'customizer.breed_zuchon': '比熊西施犬',
        'customizer.breed_other_mixed': '其他/混种',

        // 猫的品种翻译
        'customizer.breed_abyssinian': '阿比西尼亚猫',
        'customizer.breed_american_bobtail': '美国短尾猫',
        'customizer.breed_american_curl': '美国卷耳猫',
        'customizer.breed_american_shorthair': '美国短毛猫',
        'customizer.breed_balinese': '巴厘猫',
        'customizer.breed_bengal': '孟加拉猫',
        'customizer.breed_birman': '伯曼猫',
        'customizer.breed_bombay': '孟买猫',
        'customizer.breed_british_shorthair': '英国短毛猫',
        'customizer.breed_burmese': '缅甸猫',
        'customizer.breed_chartreux': '夏特尔猫',
        'customizer.breed_cornish_rex': '康沃尔卷毛猫',
        'customizer.breed_cymric': '威尔士猫',
        'customizer.breed_devon_rex': '德文卷毛猫',
        'customizer.breed_egyptian_mau': '埃及猫',
        'customizer.breed_exotic_shorthair': '异国短毛猫',
        'customizer.breed_havana_brown': '哈瓦那棕猫',
        'customizer.breed_japanese_bobtail': '日本短尾猫',
        'customizer.breed_korat': '呵叻猫',
        'customizer.breed_laperm': '拉邦猫',
        'customizer.breed_maine_coon': '缅因猫',
        'customizer.breed_manx': '马恩岛猫',
        'customizer.breed_munchkin': '曼基康猫',
        'customizer.breed_nebelung': '尼比龙猫',
        'customizer.breed_norwegian_forest_cat': '挪威森林猫',
        'customizer.breed_ocicat': '奥西猫',
        'customizer.breed_oriental': '东方猫',
        'customizer.breed_oriental_shorthair': '东方短毛猫',
        'customizer.breed_pastel_calico': '淡色三花猫',
        'customizer.breed_persian': '波斯猫',
        'customizer.breed_pixie_bob': '精灵短尾猫',
        'customizer.breed_ragamuffin': '布偶猫变种',
        'customizer.breed_ragdoll': '布偶猫',
        'customizer.breed_russian_blue': '俄罗斯蓝猫',
        'customizer.breed_scottish_fold': '苏格兰折耳猫',
        'customizer.breed_selkirk_rex': '塞尔凯克卷毛猫',
        'customizer.breed_siamese': '暹罗猫',
        'customizer.breed_siberian': '西伯利亚猫',
        'customizer.breed_singapura': '新加坡猫',
        'customizer.breed_snowshoe': '雪鞋猫',
        'customizer.breed_somali': '索马里猫',
        'customizer.breed_sphynx': '斯芬克斯猫',
        'customizer.breed_tonkinese': '东奇尼猫',
        'customizer.breed_tortoiseshell': '玳瑁猫',
        'customizer.breed_turkish_angora': '土耳其安哥拉猫',
        'customizer.breed_turkish_van': '土耳其梵猫',

        // 马的品种翻译
        'customizer.breed_andalusian': '安达卢西亚马',
        'customizer.breed_appaloosa': '阿帕卢萨马',
        'customizer.breed_arabian': '阿拉伯马',
        'customizer.breed_clydesdale': '克莱兹代尔马',
        'customizer.breed_friesian': '弗里西亚马',
        'customizer.breed_mustang': '野马',
        'customizer.breed_paint': '花马',
        'customizer.breed_quarter_horse': '夸特马',
        'customizer.breed_shetland_pony': '设得兰矮马',
        'customizer.breed_thoroughbred': '纯血马',

        // 其他动物品种翻译
        'customizer.breed_alpaca': '羊驼',
        'customizer.breed_angus': '安格斯牛',
        'customizer.breed_chinchilla': '龙猫',
        'customizer.breed_ferret': '雪貂',
        'customizer.breed_guinea_pig': '豚鼠',
        'customizer.breed_hamster': '仓鼠',
        'customizer.breed_hedgehog': '刺猬',
        'customizer.breed_llama': '美洲驼',
        'customizer.breed_pig': '猪',
        'customizer.breed_rabbit': '兔子',

        // 补充缺失的品种翻译
        'customizer.breed_airedale': '万能梗',
        'customizer.breed_american_english_coonhound': '美国英国浣熊猎犬',
        'customizer.breed_american_hairless_terrier': '美国无毛梗',
        'customizer.breed_american_wirehair': '美国硬毛猫',
        'customizer.breed_appenzeller_sennenhund': '阿彭策尔山地犬',
        'customizer.breed_aussiedoodle': '澳洲牧羊犬贵宾犬',
        'customizer.breed_balinese_javanese': '巴厘爪哇猫',
        'customizer.breed_beaglier': '比格骑士犬',
        'customizer.breed_berger_blanc_suisse': '白色瑞士牧羊犬',
        'customizer.breed_bichpoo': '比熊贵宾犬',
        'customizer.breed_black_mouthed_cur': '黑嘴杂种犬',
        'customizer.breed_bolonka': '俄罗斯玩具犬',
        'customizer.breed_borador': '边境拉布拉多犬',
        'customizer.breed_bordoodle': '边境贵宾犬',
        'customizer.breed_burmilla': '金吉拉缅甸猫',
        'customizer.breed_carolina_dog': '卡罗来纳犬',
        'customizer.breed_caucasian_shepherd': '高加索牧羊犬',
        'customizer.breed_cavachon': '骑士比熊犬',
        'customizer.breed_cavapoo': '骑士贵宾犬',
        'customizer.breed_cesky_terrier': '捷克梗',
        'customizer.breed_cheeks': '脸颊猫',
        'customizer.breed_chinese_crested_dog': '中国冠毛犬',
        'customizer.breed_chinese_li_hua': '中国狸花猫',
        'customizer.breed_chinook': '奇努克犬',
        'customizer.breed_chion': '吉娃娃乳突犬',
        'customizer.breed_chiweenie': '吉娃娃腊肠犬',
        'customizer.breed_chorkie': '吉娃娃约克夏犬',
        'customizer.breed_cockapoo': '可卡贵宾犬',
        'customizer.breed_color_point_shorthair': '重点色短毛猫',
        'customizer.breed_czechoslovakian_wolfdog': '捷克斯洛伐克狼犬',
        'customizer.breed_dogo_argentino': '阿根廷杜高犬',
        'customizer.breed_domestic_long_hair': '家养长毛猫',
        'customizer.breed_domestic_short_hair': '家养短毛猫',
        'customizer.breed_doxiepoo': '腊肠贵宾犬',
        'customizer.breed_dutch_shepherd': '荷兰牧羊犬',
        'customizer.breed_english_pointer': '英国指示犬',
        'customizer.breed_eurasier': '欧亚犬',
        'customizer.breed_european_burmese': '欧洲缅甸猫',
        'customizer.breed_exotic': '异国猫',
        'customizer.breed_griffon_bruxellois': '布鲁塞尔格里芬犬',
        'customizer.breed_groenendael': '比利时牧羊犬',
        'customizer.breed_himalayan': '喜马拉雅猫',
        'customizer.breed_hovawart': '霍瓦沃特犬'
    };
}

function generateSection(title, imagesAndPositions) {
    let sizeData = null;
    const sectionContainer = document.createElement("div");
    sectionContainer.className = "section-container";

    if (imagesAndPositions && imagesAndPositions.length > 0) {
        const heading = document.createElement("div");
        heading.classList.add("section-heading");

        const Description = document.createElement('div');
        Description.classList.add("section-description");

        if (title === "Size") {
            heading.textContent = title;
            if (isSizeChartAvailable(sizeData)) {
                var popUpButton = document.createElement("p");
                popUpButton.textContent = "View Size Chart";
                popUpButton.setAttribute("tabindex", "0");
                popUpButton.classList.add("viewSizeChart");
                popUpButton.addEventListener("keydown", handleSizeChartKeyDown);
                popUpButton.addEventListener("click", function () {
                    openPopup();
                });
                heading.appendChild(popUpButton);
            }
        } else {
            heading.textContent = 'Select ' + title + ' Position';
            Description.textContent = 'Select your plush clone’s ' + title + ' Position';
        }
        sectionContainer.appendChild(heading);
        sectionContainer.appendChild(Description);
    }


    const section = document.createElement("div");
    section.classList.add('productPositions', title.toLowerCase());

    sectionContainer.appendChild(section);
    container.appendChild(sectionContainer);

    if (imagesAndPositions && imagesAndPositions.length > 0) {
        generatePetImages(imagesAndPositions, section, title);
    }
}

function generatePetImages(imagesAndPositions, section, title) {
    imagesAndPositions.forEach(item => {
        const positionTitle = title.toLowerCase();
        const div = document.createElement("div");
        const label = document.createElement('label');

        const radioInput = document.createElement('input');
        radioInput.setAttribute('type', 'radio');
        radioInput.setAttribute('name', 'properties[' + positionTitle + ']');
        radioInput.setAttribute('value', item.value);
        radioInput.setAttribute("id", positionTitle + "-position");
        radioInput.tabIndex = -1;

        if (title === "Size") {
            const sizeButton = document.createElement("button");
            sizeButton.classList.add("size-chart-button");
            sizeButton.setAttribute("id", "size-chart-button")
            sizeButton.textContent = item.name;

            const newDiv = document.createElement("div");
            newDiv.classList.add(title.toLowerCase() + '-label');
            newDiv.appendChild(sizeButton)
            label.appendChild(radioInput);
            label.appendChild(newDiv);

            sizeButton.addEventListener("click", (event) => {
                event.preventDefault();
                // Remove border from all images
                document.querySelectorAll('.size-label button').forEach(button => {
                    button.classList.remove('selected');
                });
                var closestInput = document.getElementById('size-chart-button').closest('label').querySelector('input[type="radio"]');
                closestInput.checked = true;
                sizeButton.classList.add('selected');

                // Set the position value to the input field
                const positionInput = document.getElementById(positionTitle + "-position");
                if (positionInput) {
                    positionInput.value = item.value;
                } else {
                    console.error("Input field for", title, "not found.");
                }
            });

            div.classList.add("size-chart-buttons");
            div.appendChild(label);
        } else {
            const img = document.createElement("img");
            img.src = item.src;
            img.alt = item.alt;
            img.setAttribute("aria-label", `${positionTitle}position ${item.alt}`);

            img.setAttribute("tabindex", "0");
            //img.addEventListener("keydown", handlePetPositionKeydown);

            const newDiv = document.createElement("div");
            newDiv.classList.add(title.toLowerCase() + '-label', 'final-product-positions');
            newDiv.appendChild(img)
            label.appendChild(radioInput);
            label.appendChild(newDiv);

            const p = document.createElement("p");
            p.classList.add("position-label");
            p.textContent = item.name;

            // Add click event listener to the image
            img.addEventListener("click", function () {
                // Remove border from all images
                document.querySelectorAll('.body-position-image img').forEach(image => {
                    image.classList.remove('selected');
                });

                // Add border to the clicked image
                img.classList.add('selected');

                // Set the position value to the input field
                const positionInput = document.getElementById(positionTitle + "-position");
                if (positionInput) {
                    positionInput.value = item.value;
                } else {
                    console.error("Input field for", title, "not found.");
                }
            });

            div.classList.add("body-position-image");
            div.appendChild(label);
            div.appendChild(p);
        }
        section.appendChild(div);
    });
}

let selectedPetTypeName = '';
var selectedBreedValue;
let productOptionDisplay = true;

// 清空表单所有已填写的内容
function clearFormData() {
    // 清空宠物名称
    const petNameInput = document.getElementById('petname');
    if (petNameInput) petNameInput.value = '';

    // 清空联系信息
    const emailInput = document.getElementById('contact-email');
    if (emailInput) emailInput.value = '';

    const wechatInput = document.getElementById('contact-wechat');
    if (wechatInput) wechatInput.value = '';

    const phoneInput = document.getElementById('contact-phone');
    if (phoneInput) phoneInput.value = '';

    // 重置宠物年龄选择
    const petAgeSelect = document.getElementById('petAge');
    if (petAgeSelect) petAgeSelect.selectedIndex = 0;

    // 重置品种选择器
    const breedSelect = document.getElementById('breedSelect');
    if (breedSelect) {
        breedSelect.innerHTML = '';
        const defaultOption = document.createElement('option');
        defaultOption.value = '';
        defaultOption.text = 'Pug, Beagle, Great Dane, etc';
        defaultOption.disabled = true;
        defaultOption.selected = true;
        breedSelect.appendChild(defaultOption);
    }

    // 清空品种文本输入框
    const breedTextInput = document.getElementById('breedTextInput');
    if (breedTextInput) breedTextInput.value = '';

    // 清空其他品种输入框
    const otherBreedInput = document.getElementById('other-breed');
    if (otherBreedInput) otherBreedInput.value = '';

    // 隐藏其他品种输入框
    const otherMixedDiv = document.querySelector('.otherMixedDiv');
    if (otherMixedDiv) otherMixedDiv.style.display = 'none';

    // 清空上传的图片
    const previewContainer = document.getElementById('preview');
    if (previewContainer) previewContainer.innerHTML = '';

    // 重置上传相关的全局变量
    if (typeof uploadedImagesData !== 'undefined') {
        uploadedImagesData = {
            petImages: [],
            furColorImage: null,
            furLengthImage: null,
            petAgeImage: null
        };
    }

    // 清空图片选择区域
    const colorPreview = document.querySelector('.Color_preview');
    if (colorPreview) colorPreview.innerHTML = '';

    const lengthPreview = document.querySelector('.Length_preview');
    if (lengthPreview) lengthPreview.innerHTML = '';

    const agePreview = document.querySelector('.Age_preview');
    if (agePreview) agePreview.innerHTML = '';

    // 清空带空格的预览区域（如果存在）
    const furColorPreview = document.querySelector('.Fur Color_preview');
    if (furColorPreview) furColorPreview.innerHTML = '';

    const furLengthPreview = document.querySelector('.Fur Length_preview');
    if (furLengthPreview) furLengthPreview.innerHTML = '';

    const petAgePreview = document.querySelector('.Pet Age_preview');
    if (petAgePreview) petAgePreview.innerHTML = '';

    // 清空图片链接隐藏输入框
    const imageLinksContainer = document.getElementById('image-links');
    if (imageLinksContainer) imageLinksContainer.innerHTML = '';

    // 清空所有问题图片容器
    document.querySelectorAll('.question-image-container').forEach(container => {
        container.remove();
    });

    // 重置上传控件显示状态
    const uploadDiv = document.querySelectorAll('.uploadOuter');
    const capacityDiv = document.querySelector('.image-capacity-full-container');

    uploadDiv.forEach(uploader => {
        uploader.style.display = "block";
    });

    if (capacityDiv) {
        capacityDiv.style.display = "none";
    }
}

// 重置所有步骤为disabled状态
function resetAllSteps() {
    const step2 = document.querySelector('.step2');
    const step3 = document.querySelector('.step3');
    const step4 = document.querySelector('.step4');
    const step5 = document.querySelector('.step5');
    const step6 = document.querySelector('.step6');
    const imageDetailsContainer = document.querySelector('.image-details-container');

    if (step2) step2.classList.add('disabled');
    if (step3) step3.classList.add('disabled');
    if (step4) step4.classList.add('disabled');
    if (step5) step5.classList.add('disabled');
    if (step6) step6.classList.add('disabled');
    if (imageDetailsContainer) imageDetailsContainer.classList.add('disabled');
}

function selectedPetType(event) {
    // 清空表单所有已填写的内容
    clearFormData();

    // 重置所有步骤为disabled状态
    resetAllSteps();

    document.querySelectorAll('.pet-image-container').forEach(petImage => petImage.classList.remove('active'));
    document.querySelectorAll('.pet-image').forEach(petImage => petImage.classList.remove('active'));
    var element = event.target;
    var container = element.closest('.pet-image-container');
    if (container) {
        container.classList.add('active');

        var image = container.querySelector('.pet-image');
        if (image) {
            image.classList.add('active');
        }
    }
    selectedPetTypeName = element.closest('.pet-image-container').getAttribute('data-value') || element.closest('.pet-image').getAttribute('data-value');

    const breedSelectContainer = document.getElementById('breedSelectContainer');
    const breedTextContainer = document.getElementById('breedTextContainer');
    const breedTextInput = document.getElementById('breedTextInput');
    var select = document.getElementById('breedSelect');

    // 如果选择的是"其他"宠物类型
    if (selectedPetTypeName === 'other') {
        // 隐藏下拉选择器，显示文本输入框
        breedSelectContainer.style.display = 'none';
        breedTextContainer.style.display = 'block';
        breedTextInput.value = ''; // 清空文本输入框
    } else {
        // 显示下拉选择器，隐藏文本输入框
        breedSelectContainer.style.display = 'block';
        breedTextContainer.style.display = 'none';

        // 填充品种选择器选项
        select.innerHTML = '';
        var defaultOption = document.createElement('option');
        defaultOption.value = '';

        // 根据当前语言设置默认选项文本
        const currentLang = getCurrentLanguage();
        if (currentLang === 'zh-cn') {
            defaultOption.text = '巴哥犬、比格犬、大丹犬等';
        } else {
            defaultOption.text = 'Pug, Beagle, Great Dane, etc';
        }

        defaultOption.disabled = true;
        defaultOption.selected = true;
        select.appendChild(defaultOption);

        breeds_data[selectedPetTypeName].forEach(function (breed) {
            var option = document.createElement('option');
            option.value = breed?.description;

            // 使用翻译函数获取品种名称的翻译
            const translatedName = translateBreedName(breed?.description);
            option.text = translatedName;

            option.setAttribute('data-breathing-box', breed?.breathing_box);
            select.appendChild(option);
        });
    }

    select.addEventListener('change', function (event) {
        const divStep2 = document.querySelector('.step-2');
        selectedBreedValue = event.target.value;

        if (selectedBreedValue === 'Other/Mixed') {
            document.querySelector('.otherMixedDiv').style.display = 'block';
        } else {
            document.querySelector('.otherMixedDiv').style.display = 'none';
        }

        // Breathing Box hide/show for specifc dog breeds
        const selectedOption = select.options[select.selectedIndex];
        const hasBreathingBoxValue = selectedOption.getAttribute('data-breathing-box') === 'true';

        const breathingBoxAddon = document.querySelector('.breathing_box_body');

        if (breathingBoxAddon) {
            if (hasBreathingBoxValue) {
                breathingBoxAddon.style.display = 'flex';
            } else {
                breathingBoxAddon.style.display = 'none';
            }
        }
    });

    document.getElementById('pet-type').value = selectedPetTypeName;
    const earSection = document.getElementById('earImagesContainer');
    if (productOptionDisplay) {
        updatePetImages(selectedPetTypeName);
    }
    if (selectedPetTypeName !== "other") {
        handleEarImages(selectedPetTypeName);
        earSection.style.padding = "20px 4px 50px";
    } else {
        earSection.style.display = 'none';
        earSection.style.padding = "0px";
    }
}

function scrollToElement(event) {
    event.preventDefault();
    var element = document.getElementById('get-to-know');

    if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
    }
}

async function dragNdrop(event) {
    let preview = document.getElementById("preview");
    let Color_preview = document.querySelector(".Color_preview");
    let Length_preview = document.querySelector(".Length_preview");
    let Age_preview = document.querySelector(".Age_preview");
    const ExtraImagesUpload = document.querySelectorAll(".ExtraImage-Upload");


    let totalImages = document.querySelectorAll('#preview .image-container');
    const uploadedImages = preview.querySelectorAll("img");

    var files = event.target.files;

    let imageName;


    if ((totalImages.length + files.length) > maxImages) {
        alert("Maximum allowed images is " + maxImages + ". You are trying to upload " + (totalImages.length + files.length) + " images.");
        return;
    }

    for (let i = 0; i < files.length; i++) {
        let imageContainer = document.createElement("div");

        let colorQuestionContainer = document.createElement("div");
        let lengthQuestionContainer = document.createElement("div");
        let ageQuestionContainer = document.createElement("div");

        const DescBox_Container = document.createElement("div");
        const DescBox = document.createElement("div");
        let previewImg = document.createElement("img");
        const ext = files[i].name.split('.').pop().toLowerCase();

        if (!files[i].type.startsWith('image/')) {
            // fallback for windows : allow heic/heif if extension matches
            if (ext !== "heic" && ext !== "heif") {
                alert("Please select only image files.");
                return;
            }
        }

        if (files[i].type !== "image/jpg" && files[i].type !== "image/png" && files[i].type !== "image/bmp" && files[i].type !== "image/jpeg" && files[i].type !== "image/heic" && files[i].type !== "image/heif") {
            // fallback for windows : allow heic/heif if extension matches
            if (ext !== "heic" && ext !== "heif") {
                alert(`This type of image is not allowed. Please use only jpg, png, bmp , heic or heif.`);
                return;
            }
        }


        if (files[i].size > 15 * 1024 * 1024) {
            alert("Please select images smaller than 15MB.");
            return;
        }


        // 立即显示本地图片预览
        const localImageUrl = URL.createObjectURL(files[i]);
        previewImg.setAttribute("src", localImageUrl);
        previewImg.setAttribute("tabindex", "0");
        previewImg.alt = `Questionimage_${totalImages.length}`;
        preview.appendChild(previewImg);

        let colorImg = previewImg.cloneNode(true);
        colorImg.src = localImageUrl;
        // colorImg.addEventListener("keydown", handleQuestionImages);

        let lengthImg = previewImg.cloneNode(true);
        lengthImg.src = localImageUrl;
        // lengthImg.addEventListener("keydown", handleQuestionImages);

        let ageImg = previewImg.cloneNode(true);
        ageImg.src = localImageUrl;
        // ageImg.addEventListener("keydown", handleQuestionImages);

        //  radio for Color preview
        let colorLabelContainer = document.createElement("label");
        let colorRadioInput = document.createElement("input");
        colorRadioInput.type = "radio";
        colorRadioInput.name = "colorImagesCheckbox";
        colorRadioInput.id = `colorImageRadio${totalImages.length + i + 1}`;
        colorRadioInput.classList.add("colorImagesCheckbox");
        colorLabelContainer.setAttribute("for", `colorImageRadio${totalImages.length + i + 1}`);
        colorRadioInput.setAttribute("data-originalId", `image_${totalImages.length + i + 1}`);
        colorLabelContainer.classList.add('radio-label');
        colorLabelContainer.onclick = () => selectImage(colorRadioInput.id, colorImg);
        colorLabelContainer.appendChild(colorRadioInput);
        colorLabelContainer.appendChild(colorImg);

        //  radio Length preview
        let lengthLabelContainer = document.createElement("label");
        let lengthRadioInput = document.createElement("input");
        lengthRadioInput.type = "radio";
        lengthRadioInput.name = "lengthImagesCheckbox";
        lengthRadioInput.id = `lengthImageRadio${totalImages.length + i + 1}`;
        lengthRadioInput.classList.add("lengthImagesCheckbox");
        lengthLabelContainer.setAttribute("for", `lengthImageRadio${totalImages.length + i + 1}`);
        lengthRadioInput.setAttribute("data-originalId", `image_${totalImages.length + i + 1}`);
        lengthLabelContainer.classList.add('radio-label');
        lengthLabelContainer.onclick = () => selectImage(lengthRadioInput.id, lengthImg);
        lengthLabelContainer.appendChild(lengthRadioInput);
        lengthLabelContainer.appendChild(lengthImg);

        //  radio for Age preview
        let ageLabelContainer = document.createElement("label");
        let ageRadioInput = document.createElement("input");
        ageRadioInput.type = "radio";
        ageRadioInput.name = "ageImagesCheckbox";
        ageRadioInput.id = `ageImageRadio${totalImages.length + i + 1}`;
        ageRadioInput.classList.add("ageImagesCheckbox");
        ageLabelContainer.setAttribute("for", `ageImageRadio${totalImages.length + i + 1}`);
        ageRadioInput.setAttribute("data-originalId", `image_${totalImages.length + i + 1}`);
        ageLabelContainer.classList.add('radio-label');
        ageLabelContainer.onclick = () => selectImage(ageRadioInput.id, ageImg);
        ageLabelContainer.appendChild(ageRadioInput);
        ageLabelContainer.appendChild(ageImg);

        let questionsData = [{
            "question_text": "Please select the photo of your pet below that best represents your pet's fur color.",
            "label": "Fur Color",
            "example_text": ""
        }, {
            "question_text": "Please select the photo of your pet below that best represents your pet's fur length.",
            "label": "Fur Length",
            "example_text": "Ex.) If you want your clone to look like your pet as a puppy please select that photo."
        }, {
            "question_text": "Please select the photo of your pet below that best represents your pet's age.",
            "label": "Pet Age",
            "example_text": "Ex.) If you want your clone to look like your pet as a puppy please select that photo."
        }];
        if (questionsData && questionsData.length) {
            let Qname_furColor = Color_preview.dataset.questionName;
            let Qname_furLength = Length_preview.dataset.questionName;
            let Qname_petage = Age_preview.dataset.questionName;

            colorRadioInput.setAttribute("data-questionName", Qname_furColor);
            lengthRadioInput.setAttribute("data-questionName", Qname_furLength);
            ageRadioInput.setAttribute("data-questionName", Qname_petage);
        }

        DescBox_Container.classList.add("DescriptionBox_Container");
        DescBox.classList.add("DescriptionBox");
        DescBox.setAttribute("tabindex", "0");
        // DescBox.addEventListener("keydown", handle_DescriptionBox_textarea);
        DescBox.innerHTML = ` <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M21.7891 1.47978L22.3791 2.06978C23.1921 2.88378 23.0691 4.32678 22.1021 5.29278L9.93505 17.4598L5.99305 18.9018C5.49805 19.0838 5.01605 18.8478 4.91805 18.3768C4.88504 18.2059 4.90063 18.0292 4.96305 17.8668L6.43305 13.8908L18.5661 1.75678C19.5331 0.790781 20.9761 0.665781 21.7891 1.47978ZM9.40405 2.68978C9.53537 2.68978 9.66541 2.71565 9.78674 2.7659C9.90806 2.81616 10.0183 2.88982 10.1112 2.98267C10.204 3.07553 10.2777 3.18577 10.3279 3.3071C10.3782 3.42842 10.4041 3.55846 10.4041 3.68978C10.4041 3.8211 10.3782 3.95114 10.3279 4.07246C10.2777 4.19379 10.204 4.30403 10.1112 4.39689C10.0183 4.48975 9.90806 4.56341 9.78674 4.61366C9.66541 4.66392 9.53537 4.68978 9.40405 4.68978H5.40405C4.87362 4.68978 4.36491 4.90049 3.98984 5.27557C3.61477 5.65064 3.40405 6.15935 3.40405 6.68978V18.6898C3.40405 19.2202 3.61477 19.7289 3.98984 20.104C4.36491 20.4791 4.87362 20.6898 5.40405 20.6898H17.4041C17.9345 20.6898 18.4432 20.4791 18.8183 20.104C19.1933 19.7289 19.4041 19.2202 19.4041 18.6898V14.6898C19.4041 14.4246 19.5094 14.1702 19.6969 13.9827C19.8845 13.7951 20.1388 13.6898 20.4041 13.6898C20.6693 13.6898 20.9236 13.7951 21.1112 13.9827C21.2987 14.1702 21.4041 14.4246 21.4041 14.6898V18.6898C21.4041 19.7506 20.9826 20.7681 20.2325 21.5182C19.4823 22.2684 18.4649 22.6898 17.4041 22.6898H5.40405C4.34319 22.6898 3.32577 22.2684 2.57563 21.5182C1.82548 20.7681 1.40405 19.7506 1.40405 18.6898V6.68978C1.40405 5.62892 1.82548 4.6115 2.57563 3.86135C3.32577 3.11121 4.34319 2.68978 5.40405 2.68978H9.40405Z" fill="#5461C8"/></svg>
          `;

        const boldText = document.createElement("strong");
        boldText.textContent = "Add Image Description";

        const optionalText = document.createElement("span");
        optionalText.textContent = " (Optional)";

        DescBox.appendChild(boldText);
        DescBox.appendChild(optionalText);
        DescBox_Container.appendChild(DescBox);

        DescBox.addEventListener("click", () => {
            const container = DescBox_Container;
            let textarea = container.querySelector("textarea");

            const myContainer = DescBox.closest('.image-container');
            const imageId = myContainer.getAttribute('data-image-id');

            if (textarea) {
                // 保存描述到全局变量
                updateImageDescription(myContainer, textarea.value);
                textarea.classList.remove("show");
                boldText.textContent = "Add Image Description";
                textarea.addEventListener("transitionend", () => textarea.remove(), { once: true });
            } else {
                textarea = document.createElement("textarea");
                textarea.name = `properties[image_${imageId}_description]`;
                textarea.placeholder = "Provide unique details for our artist to pay attention to  in the photo above";
                textarea.className = "image-description";
                container.appendChild(textarea);
                textarea.focus();
                requestAnimationFrame(() => textarea.classList.add("show"));
                boldText.textContent = "Remove Image Description";

                // 添加输入事件监听器，实时更新描述
                textarea.addEventListener('input', () => {
                    updateImageDescription(myContainer, textarea.value);
                });
            }
        });


        let progressWrapper = document.createElement("div");
        progressWrapper.classList.add("progress-wrapper");

        progressWrapper.innerHTML = ` <div class="progress-status">Upload Complete</div> <div class="progress-percentage">0%</div> <svg class="progress-circle" width="40" height="40"> <circle class="progress-background" cx="20" cy="20" r="18"></circle> <circle class="progress_Bar" cx="20" cy="20" r="18"></circle></svg>
          `;
        let progressCircle = progressWrapper.querySelector('.progress-circle');
        const progressStatus = progressWrapper.querySelector('.progress-status');
        const percentage = progressWrapper.querySelector('.progress-percentage');
        // 推荐的写法：
        const formData = new FormData();
        formData.append('file', files[i]);
        fetch('https://api.paw-print.cn/index.php/api/ajax/upload', {
            method: 'POST',
            body: formData
        })
            .then(response => {

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                return response.json(); // 关键：读取 JSON 响应内容
            })
            .then(data => {
                if (data.code === 1) {

                    // 保存服务器返回的URL
                    const serverImageUrl = data.data.file.full_url;

                    // 更新图片元素的src为服务器URL
                    previewImg.src = serverImageUrl;
                    colorImg.src = serverImageUrl;
                    lengthImg.src = serverImageUrl;
                    ageImg.src = serverImageUrl;

                    // 获取图片容器的唯一ID
                    const imageContainer = previewImg.closest('.image-container');
                    const imageId = imageContainer.getAttribute('data-image-id');

                    // 获取图片描述（如果有的话）
                    let imageDescription = '';
                    if (imageContainer) {
                        const textarea = imageContainer.querySelector('textarea.image-description');
                        if (textarea) {
                            imageDescription = textarea.value;
                        }
                    }

                    // 将图片信息添加到全局数据中，包含唯一ID
                    uploadedImagesData.petImages.push({
                        id: imageId,
                        image: serverImageUrl,
                        remark: imageDescription
                    });

                    // 更新隐藏的input字段
                    handleImages();
                }
            })
            .catch(error => {
                console.error('上传失败:', error);
            });


        handleImages();

        const setHiddenInputs = document.querySelectorAll(".uploadedHiddenImages");
        const previewElement = document.getElementById("preview");
        const imageTags = previewElement.querySelectorAll("img");
        const nextButtonStep3 = step3.querySelector('.startSelectionButtonDiv');
        if (uploadedImages.length + files.length === setHiddenInputs.length) {
            if (imageTags.length >= minimumImages) {
                nextButtonStep3.style.display = "flex";
            }
        }

        var deleteButton = document.createElement("div");
        deleteButton.innerHTML = '<span class="material-icons-outlined">close</span>';
        deleteButton.classList.add("delete-button");
        deleteButton.addEventListener("click", function () {
            const imageContainer = this.parentElement;
            const imageId = imageContainer.getAttribute('data-image-id');
            var index = Array.from(this.parentElement.parentElement.children).indexOf(this.parentElement);

            // 从uploadedImagesData.petImages数组中删除对应的图片数据
            const imageIndex = uploadedImagesData.petImages.findIndex(item => item.id === imageId);
            if (imageIndex !== -1) {
                uploadedImagesData.petImages.splice(imageIndex, 1);
            }

            deleteImage(preview, index);
            // also delete same index from other containers
            if (questionsData && questionsData.length) {
                deleteImage(Color_preview, index);
                deleteImage(Length_preview, index);
                deleteImage(Age_preview, index);
            }
            if ((preview.children.length - 1) < 3) {
                document.querySelector(".startSelectionButtonDiv").style.display = "none";
            }
        });


        imageContainer.classList.add("image-container");

        // 为每个图片容器添加唯一ID
        const imageId = `image_${Date.now()}_${i}`;
        imageContainer.setAttribute('data-image-id', imageId);

        imageContainer.appendChild(progressWrapper);
        imageContainer.appendChild(deleteButton);
        imageContainer.appendChild(previewImg);
        imageContainer.appendChild(DescBox_Container);

        preview.appendChild(imageContainer);

        if (questionsData && questionsData.length) {
            colorQuestionContainer.classList.add("question-image-container");
            lengthQuestionContainer.classList.add("question-image-container");
            ageQuestionContainer.classList.add("question-image-container");

            colorQuestionContainer.appendChild(colorLabelContainer);
            lengthQuestionContainer.appendChild(lengthLabelContainer);
            ageQuestionContainer.appendChild(ageLabelContainer);


            Color_preview.appendChild(colorQuestionContainer);
            Length_preview.appendChild(lengthQuestionContainer);
            Age_preview.appendChild(ageQuestionContainer);
        }

    }

    if ((preview.children.length - 1) >= maxImages) {
        uploadDiv.forEach(uploader => {
            uploader.style.display = "none";
        })
        capacityDiv.style.display = "flex";
        alert("Maximum " + maxImages + " images are uploaded ");
    } else {
        uploadDiv.forEach(uploader => {
            uploader.style.display = "block";
        })

        capacityDiv.style.display = "none";
    }
}

function updateProgress(progressWrapper, percent) {
    const progressBar = progressWrapper.querySelector('.progress_Bar');
    const percentageText = progressWrapper.querySelector('.progress-percentage');
    const progressStatus = progressWrapper.querySelector('.progress-status');

    const radius = 18;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (percent / 100) * circumference;

    progressBar.style.strokeDashoffset = offset;
    percentageText.textContent = `${percent}%`;

    if (percent >= 100) {
        progressStatus.textContent = 'Upload Complete';

    }
}

function handleImages() {
    const previewElement = document.getElementById("preview");
    // Check if the element exists
    if (previewElement) {
        const imageTags = previewElement.querySelectorAll("img");
        // Convert NodeList to array (if needed)
        const imageTagsArray = Array.from(imageTags);
        const imageLinksElement = document.getElementById("image-links");
        // imageLinksElement.style.display="none";
        if (imageLinksElement) {
            imageLinksElement.remove();
        }
        const divElement = document.createElement("div");


        // Set the id attribute to "image-lnks"
        divElement.setAttribute("id", "image-links");

        imageTagsArray.forEach((element, index) => {
            const hiddenInput = document.createElement('input');
            hiddenInput.setAttribute("type", "hidden");
            hiddenInput.setAttribute("class", "uploadedHiddenImages");
            hiddenInput.setAttribute("name", "properties[image_" + (index + 1) + "]");
            hiddenInput.setAttribute("data-id", "image_" + (index + 1));
            hiddenInput.setAttribute("value", element.src);
            divElement.appendChild(hiddenInput);
        });
        const imagePreview = document.getElementById('preview');
        imagePreview.appendChild(divElement);
    }
}


function deleteImage(container, index) {
    container.removeChild(container.children[index]);

    if ((container.children.length - 1) < maxImages) {
        uploadDiv.forEach(uploader => {
            uploader.style.display = "block";
        })
        capacityDiv.style.display = "none";
    }
}


function drag() {
    document.getElementById("uploadFile").parentNode.parentNode.className = "dragBox";
}

function drop() {
    document.getElementById("uploadFile").parentNode.parentNode.className = "dragBox";
}

function showHideTwoPallets(checkbox) {
    var newElement = document.querySelectorAll(".color-container .second-half");
    const secondHalf = document.getElementsByClassName("second-half");
    if (checkbox.checked) {
        secondHalf.style.display = "block";
    }
    // Update colorItems after cloning
    const colorItems = document.querySelectorAll('.color');
    colorItems.forEach(item => {
        item.onclick = selectColor; // Reassign onclick event
    });
}

// Update colorItems after cloning
const colorItems = document.querySelectorAll('.color');
colorItems.forEach(item => {
    item.onclick = selectColor; // Reassign onclick event
});

function selectColor(event) {
    const selectedColor = event.currentTarget;

    // Check if the color is in the first half or the second half
    const firstHalf = document.getElementById("color_container").children[0];
    const secondHalf = document.getElementById("color_container").children[1];

    const isFirstHalf = firstHalf.contains(selectedColor);
    const isSecondHalf = secondHalf && secondHalf.contains(selectedColor);

    // If the color is already selected, remove the selection
    if (selectedColor.classList.contains('selected')) {
        selectedColor.classList.remove('selected');
        const tickIcon = selectedColor.querySelector('.material-icons');
        if (tickIcon) {
            selectedColor.removeChild(tickIcon);
        }
        return;
    }

    // If the color is from the first half, deselect all colors in the first half
    if (isFirstHalf) {
        firstHalf.querySelectorAll('.color.selected').forEach(item => {
            item.classList.remove('selected');
            const tickIcon = item.querySelector('.material-icons');
            if (tickIcon) {
                item.removeChild(tickIcon);
            }
        });
    }

    // If the color is from the second half, deselect all colors in the second half
    if (isSecondHalf) {
        secondHalf.querySelectorAll('.color.selected').forEach(item => {
            item.classList.remove('selected');
            const tickIcon = item.querySelector('.material-icons');
            if (tickIcon) {
                item.removeChild(tickIcon);
            }
        });
    }

    // Add selection to the clicked color
    selectedColor.classList.add('selected');
    const tickIcon = document.createElement('i');
    tickIcon.classList.add('material-icons');
    tickIcon.textContent = 'done';
    selectedColor.appendChild(tickIcon);
}


var maxImages = 10;
var preview = document.getElementById("preview");
var uploadDiv = document.querySelectorAll(".uploadOuter");
var capacityDiv = document.querySelector(".image-capacity-full-container");

var sizeData = null;

capacityDiv.style.display = "none";

function updatePetImages(selectedPetTypeName) {
    container.innerHTML = "";

    var earImages = document.getElementById("earImagesContainer");
    if (selectedPetTypeName === "dog") {
        earImages.style.display = "block";
    } else {
        earImages.style.display = "none";
    }

    var productOptions = [{ "main_heading": "Product Options" }, {
        "dog": {
            "Mouth": {
                "display": true,
                "images_and_positions": [{
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/close-mouth-no-tongue.png?v=1707226429",
                    "alt": "Closed No Tongue",
                    "name": "Closed No Tongue",
                    "value": "closed-no-tongue"
                }, {
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/close-mouth-with-tongue.png?v=1707226429",
                    "alt": "Closed With Tongue",
                    "name": "Closed With Tongue",
                    "value": "closed-with-tongue"
                }, {
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/open-mouth-with-tongue.png?v=1707226429",
                    "alt": "Open With Tongue",
                    "name": "Open With Tongue",
                    "value": "open-with-tongue"
                }]
            },
            "Body": {
                "display": false,
                "images_and_positions": [{
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/laying.png?v=1707226430",
                    "alt": "Laying Down",
                    "name": "Laying Down",
                    "value": "laying-down"
                }, {
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/sitting.png?v=1707226429",
                    "alt": "Sitting",
                    "name": "Sitting",
                    "value": "sitting"
                }, {
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/standing.png?v=1707226429",
                    "alt": "Standing",
                    "name": "Standing",
                    "value": "standing"
                }]
            },
            "Tail": {
                "display": false,
                "images_and_positions": [{
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/down.png?v=1707226430",
                    "alt": "Down",
                    "name": "Down",
                    "value": "down"
                }, {
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/half.png?v=1707226430",
                    "alt": "Half",
                    "name": "Half",
                    "value": "half"
                }, {
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/up.png?v=1707226429",
                    "alt": "Up",
                    "name": "Up",
                    "value": "up"
                }, {
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/none.png?v=1707226430",
                    "alt": "None",
                    "name": "None",
                    "value": "none"
                }]
            }
        },
        "cat": {
            "Body": {
                "display": false,
                "images_and_positions": [{
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/cat-laying.png?v=1707226430",
                    "alt": "Laying Down",
                    "name": "Laying Down",
                    "value": "laying-down"
                }, {
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/cat-sitting.png?v=1707226430",
                    "alt": "Sitting",
                    "name": "Sitting",
                    "value": "sitting"
                }]
            },
            "Tail": {
                "display": false,
                "images_and_positions": [{
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/cat-tail-yes.png?v=1707226430",
                    "alt": "Yes",
                    "name": "Yes",
                    "value": "Yes"
                }, {
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/cat-no-tail.png?v=1707226429",
                    "alt": "No Tail",
                    "name": "None",
                    "value": "none"
                }]
            },
            "Mouth": { "display": false, "images_and_positions": {} }
        },
        "horse": {
            "Body": {
                "display": false,
                "images_and_positions": [{
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/horse-laying.png?v=1707226429",
                    "alt": "Laying Down",
                    "name": "Laying Down",
                    "value": "laying-down"
                }, {
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/horse-standing.png?v=1707226429",
                    "alt": "Standing",
                    "name": "Standing",
                    "value": "standing"
                }]
            },
            "Tail": {
                "display": false,
                "images_and_positions": [{
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/horse-up.png?v=1707226429",
                    "alt": "Up",
                    "name": "Up",
                    "value": "up"
                }, {
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/horse-down.png?v=1707226429",
                    "alt": "Down",
                    "name": "Down",
                    "value": "down"
                }, {
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/horse-docked-tail.png?v=1707226428",
                    "alt": "Bobtail",
                    "name": "Bobtail",
                    "value": "bobtail"
                }]
            },
            "Mouth": { "display": false, "images_and_positions": {} }
        }
    }, { "display": true }];

    // Iterate over each product option
    productOptions.forEach(function (option) {
        // Check if the selected pet type exists in the option
        if (selectedPetTypeName in option) {
            var petData = option[selectedPetTypeName];
            if (checkDisplayTrue(petData)) {
                if (Object.keys(petData).length > 0) {

                    Object.keys(petData).forEach(function (position) {
                        if (petData[`${position}`].display) {
                            generateSection(position, petData[`${position}`].images_and_positions);
                        }
                    });

                    if (rushSection) {
                        finalStepButton.innerHTML = 'Next Step';
                    } else {
                        finalStepButton.innerHTML = 'Final Step';
                    }
                }
            }
        }
    });
}

function validatePlushCloneOptions(event) {
    event.preventDefault();

    const petInfo = document.querySelector('#pet-info');
    const leftEyeColorInput = document.getElementById('left-eye-color');
    const rightEyeColorInput = document.getElementById('right-eye-color');
    const leftEyeColor = leftEyeColorInput.value.trim();
    const rightEyeColor = rightEyeColorInput.value.trim();

    if (!leftEyeColor || !rightEyeColor) {
        alert("Please select eye colors for both eyes.");
        petInfo.scrollIntoView({ behavior: 'smooth' });
        return;
    }

    const earImagesContainer = document.querySelector("#earImagesContainer");
    const isEarVisible = earImagesContainer && earImagesContainer.style.display !== "none";
    const hasEarOptions = earImagesContainer && earImagesContainer.innerHTML.trim() !== "";
    if (isEarVisible && hasEarOptions) {
        const leftEarInputs = step4.querySelectorAll('input[name="properties[_pet_left_ear]"]');
        const rightEarInputs = step4.querySelectorAll('input[name="properties[_pet_right_ear]"]');
        const toggle = document.getElementById("different-ear-position");
        const isDifferent = toggle?.checked;

        const leftEarSelected = Array.from(leftEarInputs).some(input => input.checked);
        const rightEarSelected = Array.from(rightEarInputs).some(input => input.checked);

        let validEars = false;
        if (isDifferent) {
            validEars = leftEarSelected && rightEarSelected;
        } else {
            validEars = leftEarSelected;
        }

        if (!validEars) {
            alert(isDifferent ?
                "Please select ear positions for both left and right ears." :
                "Please select an ear position."
            );
            earImagesContainer.scrollIntoView({ behavior: 'smooth' });
            return;
        }
    }

    const productOptions = [{ "main_heading": "Product Options" }, {
        "dog": {
            "Mouth": {
                "display": true,
                "images_and_positions": [{
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/close-mouth-no-tongue.png?v=1707226429",
                    "alt": "Closed No Tongue",
                    "name": "Closed No Tongue",
                    "value": "closed-no-tongue"
                }, {
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/close-mouth-with-tongue.png?v=1707226429",
                    "alt": "Closed With Tongue",
                    "name": "Closed With Tongue",
                    "value": "closed-with-tongue"
                }, {
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/open-mouth-with-tongue.png?v=1707226429",
                    "alt": "Open With Tongue",
                    "name": "Open With Tongue",
                    "value": "open-with-tongue"
                }]
            },
            "Body": {
                "display": false,
                "images_and_positions": [{
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/laying.png?v=1707226430",
                    "alt": "Laying Down",
                    "name": "Laying Down",
                    "value": "laying-down"
                }, {
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/sitting.png?v=1707226429",
                    "alt": "Sitting",
                    "name": "Sitting",
                    "value": "sitting"
                }, {
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/standing.png?v=1707226429",
                    "alt": "Standing",
                    "name": "Standing",
                    "value": "standing"
                }]
            },
            "Tail": {
                "display": false,
                "images_and_positions": [{
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/down.png?v=1707226430",
                    "alt": "Down",
                    "name": "Down",
                    "value": "down"
                }, {
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/half.png?v=1707226430",
                    "alt": "Half",
                    "name": "Half",
                    "value": "half"
                }, {
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/up.png?v=1707226429",
                    "alt": "Up",
                    "name": "Up",
                    "value": "up"
                }, {
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/none.png?v=1707226430",
                    "alt": "None",
                    "name": "None",
                    "value": "none"
                }]
            }
        },
        "cat": {
            "Body": {
                "display": false,
                "images_and_positions": [{
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/cat-laying.png?v=1707226430",
                    "alt": "Laying Down",
                    "name": "Laying Down",
                    "value": "laying-down"
                }, {
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/cat-sitting.png?v=1707226430",
                    "alt": "Sitting",
                    "name": "Sitting",
                    "value": "sitting"
                }]
            },
            "Tail": {
                "display": false,
                "images_and_positions": [{
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/cat-tail-yes.png?v=1707226430",
                    "alt": "Yes",
                    "name": "Yes",
                    "value": "Yes"
                }, {
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/cat-no-tail.png?v=1707226429",
                    "alt": "No Tail",
                    "name": "None",
                    "value": "none"
                }]
            },
            "Mouth": { "display": false, "images_and_positions": {} }
        },
        "horse": {
            "Body": {
                "display": false,
                "images_and_positions": [{
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/horse-laying.png?v=1707226429",
                    "alt": "Laying Down",
                    "name": "Laying Down",
                    "value": "laying-down"
                }, {
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/horse-standing.png?v=1707226429",
                    "alt": "Standing",
                    "name": "Standing",
                    "value": "standing"
                }]
            },
            "Tail": {
                "display": false,
                "images_and_positions": [{
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/horse-up.png?v=1707226429",
                    "alt": "Up",
                    "name": "Up",
                    "value": "up"
                }, {
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/horse-down.png?v=1707226429",
                    "alt": "Down",
                    "name": "Down",
                    "value": "down"
                }, {
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/horse-docked-tail.png?v=1707226428",
                    "alt": "Bobtail",
                    "name": "Bobtail",
                    "value": "bobtail"
                }]
            },
            "Mouth": { "display": false, "images_and_positions": {} }
        }
    }, { "display": true }];
    if (selectedPetTypeName && isPetTypeAvailable(selectedPetTypeName, productOptions)) {
        const selectedPetOptions = productOptions.find(opt => opt[selectedPetTypeName])[selectedPetTypeName];

        let bodyPositionError = false;

        Object.keys(selectedPetOptions).forEach(position => {
            if (bodyPositionError) return;
            const detail = selectedPetOptions[position];
            if (detail.display && detail.images_and_positions.length) {
                const positionDiv = document.querySelector(`.${position.toLowerCase()}`);
                if (!positionDiv) return;
                const bodyInputs = positionDiv.querySelectorAll('input');
                const selected = Array.from(bodyInputs).some(input => input.checked);
                if (!selected) {
                    alert(position === "Size"
                        ? `Please select ${position} for Slipper.`
                        : `Please select positions for ${position}.`);
                    positionDiv.scrollIntoView({ behavior: 'smooth' });
                    bodyPositionError = true;
                    return;
                }
            }
        });

        if (bodyPositionError) return;
    }

    if (plushFrameSection) {
        const backgroundOptions = document.getElementsByClassName('background-image');
        const frameOptions = document.getElementsByClassName('frame-image');

        const isBackgroundSelected = Array.from(backgroundOptions).some(opt => opt.checked || opt.classList.contains('selected'));
        const isFrameSelected = Array.from(frameOptions).some(opt => opt.checked || opt.classList.contains('selected'));

        // Check if frame validation should be skipped (when product.type is empty and redirecting to customizer)
        const isFromPlushClones = isFromPlushClonesCollection();

        if (!isBackgroundSelected) {
            plushFrameSection.scrollIntoView({ behavior: 'smooth' });
            alert('Please select Background');
            return;
        }

        // Only check frame selection if frame validation is not skipped
        if (!isFromPlushClones && !isFrameSelected) {
            plushFrameSection.scrollIntoView({ behavior: 'smooth' });
            alert('Please select Plush Frame');
            return;
        }
    }

    //Passed all checks → go to rush or step6
    if (rushSection) {
        rushSection.classList.remove('disabled');
        rushSection.scrollIntoView({ behavior: 'smooth' });
    } else {
        step6.classList.remove('disabled');
        step6.scrollIntoView({ behavior: 'smooth' });
    }
}


function decreaseQuantity(event) {
    event.preventDefault();
    var quantityInput = document.getElementById('quantity');
    var quantity = parseInt(quantityInput.value);
    if (quantity > 1) {
        quantity--;
        quantityInput.value = quantity;
    }
}

function increaseQuantity(event) {
    event.preventDefault();
    var quantityInput = document.getElementById('quantity');
    var quantity = parseInt(quantityInput.value);
    quantity++;
    quantityInput.value = quantity;
}

function selectRightEar(element) {
    // Remove 'selected' class from all ear images
    document.querySelectorAll('.ear-image').forEach(function (ear) {
        ear.classList.remove('selected');
    });

    // Add 'selected' class to the clicked ear image
    element.classList.add('selected');
}

function selectLeftEar(element) {
    // Remove 'selected' class from all ear images
    document.querySelectorAll('.ear-image').forEach(function (ear) {
        ear.classList.remove('selected');
    });

    // Add 'selected' class to the clicked ear image
    element.classList.add('selected');
}

const radioButtons = document.querySelectorAll('input[type="radio"]');

// Add click event listener to each radio button
radioButtons.forEach(button => {
    button.addEventListener('click', function () {
        // Get the value of the selected radio button
        const selectedValue = this.value;

        // Set the value of the input field with the selected ear value
        const inputField = document.getElementById(this.name);
        if (inputField) {
            inputField.value = selectedValue;
        }
    });
});

function showHideSecondPalette(checkbox) {
    const oneHalf = document.getElementById('ColorPaletteOneHalf');
    const secondPalette = document.getElementById('second-palette');
    const colorPaletteTab = document.querySelector('.Colorpalette-Tab');
    if (checkbox.checked) {
        colorPaletteTab.style.display = "block"
        document.getElementById("right-eye-color").value = '';
    } else {
        secondPalette.style.display = "none"
        colorPaletteTab.style.display = "none"
        oneHalf.style.display = "flex"
        // Clear the right eye color input and reset its value
        var left_eye_color = document.getElementById("left-eye-color").value;
        var right_eye_color = document.getElementById("right-eye-color").value;
        if ((left_eye_color) && (left_eye_color != right_eye_color)) {
            document.getElementById("right-eye-color").value = left_eye_color
        }
    }
}

function setEyeColor(checkbox, eyeSide, color) {
    const eyeCheckbox = document.getElementById("different-eye-color");

    let colorName = color.toLowerCase().replace(/\s/g, "_");
    // Set the color for the specified eye
    document.getElementById(`${eyeSide}-eye-color`).value = colorName;

    if (!eyeCheckbox.checked) {
        document.getElementById("right-eye-color").value = colorName;
        document.getElementById("left-eye-color").value = colorName;
    } else {
        // Set the color for the specified eye
        if (eyeSide === 'right') {
            document.getElementById("right-eye-color").value = colorName;
        } else if (eyeSide === 'left') {
            document.getElementById("left-eye-color").value = colorName;
        }
    }
}

const stepSpecieType = document.querySelector('.step_SpecieType');
const step2 = document.querySelector('.step2');
const step3 = document.querySelector('.step3');
const step4 = document.querySelector('.step4');
const step5 = document.querySelector('.step5');
const step6 = document.querySelector('.step6');

const imageDetailSection = document.querySelector(".image-details-container")
const plushFrameSection = document.querySelector('.plush-frame-options');
const rushSection = document.querySelector('.rushContainer_Parent');
const finalStepButton = document.getElementById("final-step-button");

step2.classList.add('disabled');
step3.classList.add('disabled');
step4.classList.add('disabled');
step5.classList.add('disabled');
step6.classList.add('disabled');

if (imageDetailSection) {
    imageDetailSection.classList.add('disabled');
}

if (rushSection) {
    rushSection.classList.add('disabled');
}

const emailInput = step2.querySelector('.email');
const nextButtonSpecieType = stepSpecieType.querySelector('.nextStep-button-SpecieType');
const nextButtonStep2 = step2.querySelector('.nextStep-button');
const nextButtonStep3 = step3.querySelector('.startSelectionButton');

let nextButtonRushSection;
if (rushSection) {
    nextButtonRushSection = rushSection.querySelector('.nextStep-button');
}


const errorMsg = document.querySelector('.error-msg');

const petTypeInput = document.getElementById('pet-type');

// Get the pet name input element
const petNameInput = step2.querySelector('input[name="properties[_pet_name]"]');
// Get the breed select element
const breedSelect = document.getElementById('breedSelect');
// Get the age select element
const ageSelect = step2.querySelector('select[name="properties[_pet_age]"]');

const mixedBreed = document.querySelector('.otherMixedInput');

const emailRegex = /^[^\s@]+@(?!.*\.\.)(?!.*\.@)[^\s@.]+(\.[^\s@.]+)*\.[a-zA-Z]{2,}$/;

nextButtonStep2.addEventListener('click', (event) => {
    const emailValue = document.querySelector("#contact-email").value.trim();
    const wechatValue = document.querySelector("#contact-wechat").value.trim();
    const phoneValue = document.querySelector("#contact-phone").value.trim();
    const specieValue = document.querySelector("#pet-type").value.trim();
    const petNameValue = document.querySelector(".petName").value.trim();
    const breedValue = document.querySelector("#breedSelect").value;
    const petAgeValue = document.querySelector("#petAge").value;
    const petAgeBlock = document.querySelector("#petAge")

    // 验证邮箱格式（如果填写了邮箱）
    const isEmailValid = emailValue === '' || emailRegex.test(emailValue);

    const klaviyouData = {
        email: emailValue,
        wechat: wechatValue,
        phone: phoneValue,
        name: petNameValue,
        species: specieValue,
        breed: breedValue,
        pet_age: petAgeValue,
    }

    const klaviyoBody = JSON.stringify(klaviyouData);

    // Check if a pet details are entered

    if (petNameInput.value.trim() === '') {
        alert("Please enter pet name.");
        petNameInput.focus();
        event.preventDefault();
    } else if (!isEmailValid) {
        alert("Please enter a valid email format");
        document.querySelector("#contact-email").scrollIntoView({ behavior: 'smooth' });
        document.querySelector("#contact-email").focus();
        event.preventDefault();
    } else if (ageSelect.value === '') {
        event.preventDefault();
        alert("Please select age of pet.");
        petAgeBlock.scrollIntoView({ behavior: 'smooth' });
    } else if (breedSelect.value === '' && selectedPetTypeName !== 'other') {
        alert("Please select any breed specie.");
        event.preventDefault();
        breedSelect.focus();
    } else if (selectedBreedValue === 'Other/Mixed' && mixedBreed.value.trim() === '') {
        alert("Please enter Other/Mixed breed name");
        mixedBreed.scrollIntoView({ behavior: 'smooth' });
        mixedBreed.focus();
    } else if (klaviyouData.email.trim() === '' && klaviyouData.wechat.trim() === '' && klaviyouData.phone.trim() === '') {
        alert("Please provide at least one form of contact information.");
        event.preventDefault();
    } else {
        step3.classList.remove('disabled');
        step3.scrollIntoView({ behavior: 'smooth' });
    }
});


nextButtonSpecieType.addEventListener('click', (event) => {
    const specieValue = document.querySelector("#pet-type").value.trim();

    // Check if a pet type is selected
    const petTypeSelected = petTypeInput.value.trim() !== '';
    const petTypeDiv = document.querySelector(".pet-images");

    if (!petTypeSelected) {
        alert("Select valid pet type.");
        event.preventDefault();
        petTypeDiv.scrollIntoView({ behavior: 'smooth' });
    } else {
        step2.classList.remove('disabled');
        step2.scrollIntoView({ behavior: 'smooth' });
    }
});

const uploadContainer = document.getElementById('dragArea');

function camelize(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
}

const thanksMessage = document.querySelector(".thanks_message");
let questionsData = [{
    "question_text": "Please select the photo of your pet below that best represents your pet's fur color.",
    "label": "Fur Color",
    "example_text": ""
}, {
    "question_text": "Please select the photo of your pet below that best represents your pet's fur length.",
    "label": "Fur Length",
    "example_text": "Ex.) If you want your clone to look like your pet as a puppy please select that photo."
}, {
    "question_text": "Please select the photo of your pet below that best represents your pet's age.",
    "label": "Pet Age",
    "example_text": "Ex.) If you want your clone to look like your pet as a puppy please select that photo."
}];

const imageTags = preview.querySelectorAll("img");

const minimumImages = 3;

nextButtonStep3.addEventListener('click', (event) => {
    event.preventDefault();
    const previewElement = document.getElementById("preview");
    const imageTags = previewElement.querySelectorAll("img");
    if (imageTags && imageTags.length >= 3) {
        if (imageDetailSection) {
            imageDetailSection.classList.remove('disabled');
            imageDetailSection.scrollIntoView({ behavior: 'smooth' });
        } else {
            step4.classList.remove('disabled');
            step4.scrollIntoView({ behavior: 'smooth' });
            step5.classList.remove('disabled');
        }
    } else {
        disableRemainingSections();
        alert("Please upload at least 3 images of your pet.");
        return;
    }
});

function disableRemainingSections() {
    const step4 = document.querySelector('.step4');
    const step5 = document.querySelector('.step5');
    const step6 = document.querySelector('.step6');
    step4.classList.add('disabled');
    step5.classList.add('disabled');
    step6.classList.add('disabled');
}

function extractStringInsideBrackets(str) {
    const match = str.match(/\[(.*?)\]/);
    return match ? match[1] : null;
}

function deleteImageRadio(container) {
    const previewElement = document.getElementById("preview");
    const previewImages = previewElement.querySelectorAll("img");
    deletedImageId = container.querySelector('img').id;
    let imagesLength;
    if (previewImages) {
        imagesLength = previewImages.length;
    }
    if (deletedImageId.startsWith("image_") && imagesLength > 3) {
        container.remove();
        document.querySelector(`input[name="properties[${deletedImageId}]"]`).remove();
    } else if (!deletedImageId.startsWith("image_") && imagesLength >= 3) {
        alert("This image is selected against the previous question");
        return;
    } else {
        alert("Minimum 3 images are required to proceed further");
        return;
    }
}

function selectImage(radioId, imgElement) {
    const radioInput = document.getElementById(radioId);
    if (!radioInput) return;

    // Check the clicked radio
    radioInput.checked = true;

    // Find the parent section (so we only clear selection in that section)
    const section = imgElement.closest('.sections');
    if (!section) return;

    const images = section.querySelectorAll('.question-image-container img');
    images.forEach(img => img.classList.remove('questionSelected'));

    imgElement.classList.add('questionSelected');

    const radios = section.querySelectorAll('input[type="radio"]');

    radios.forEach(radio => {
        const label = section.querySelector(`label[for="${radio.id}"]`);
        if (label) {
            if (radio.id === radioId) {
                radio.checked = true;
                label.classList.add('selected');
            } else {
                label.classList.remove('selected');
            }
        }
    });

    // 更新全局变量中对应的图片URL
    const imageUrl = imgElement.src;

    // 根据radioId判断是哪种类型的图片选择
    if (radioId.includes('colorImageRadio')) {
        uploadedImagesData.furColorImage = imageUrl;
    } else if (radioId.includes('lengthImageRadio')) {
        uploadedImagesData.furLengthImage = imageUrl;
    } else if (radioId.includes('ageImageRadio')) {
        uploadedImagesData.petAgeImage = imageUrl;
    }
}

// 更新图片描述的函数
function updateImageDescription(imageContainer, description) {
    // 获取图片容器的唯一ID
    const imageId = imageContainer.getAttribute('data-image-id');

    // 找到对应的图片数据并更新描述
    const imageData = uploadedImagesData.petImages.find(item => item.id === imageId);
    if (imageData) {
        imageData.remark = description;
    }
}

function hideCheckedImages() {
    imageContainers.forEach((container, index) => {
        const img = container.querySelector('img');

        if (img) {
            const radioId = img.id;

            img.onclick = () => selectImage(radioId, img);
        } else {
            if (img) {
                img.style.display = 'none';
                const closestRadio = container.querySelector('input[type="radio"]');
                if (closestRadio) {
                    closestRadio.checked = false;
                    closestRadio.name = closestRadio.name + "checked";
                }
            }
        }
    });
}


let rushSelector;

if (rushSection) {
    rushSelector = document.querySelector('.rushSelect');

    const rushRadios = document.querySelectorAll('input[name="rushCreation"]');
    const rushTypeLabel = document.getElementById('rushTypeLabel');
    const rushDate = document.getElementById('rushDate');
    const rushContainer = document.querySelector('.label_rushdate_cont');

    const shippingLabel = rushContainer.dataset.shippingLabel;
    rushRadios.forEach(radio => {
        radio.addEventListener('change', () => {
            // sync with hidden select
            rushSelector.value = radio.value;
            rushSelector.dispatchEvent(new Event('change'));

            // get weeks & name
            const weeks = parseInt(radio.dataset.weeks);
            const name = radio.dataset.name;

            // calc date
            const today = new Date();
            today.setDate(today.getDate() + weeks * 7);
            const options = { weekday: 'short', month: 'short', day: 'numeric' };
            const formattedDate = today.toLocaleDateString('en-US', options);

            // update label (rush type name)
            rushTypeLabel.textContent = `${name}:`;

            // show metafield text + date
            if (formattedDate) {
                rushDate.innerHTML = `<strong>${shippingLabel} ${formattedDate}</strong>`;
            } else {
                rushDate.textContent = '';
            }
        });
    });
}


if (rushSection) {
    nextButtonRushSection.addEventListener('click', (event) => {
        event.preventDefault();
        if (rushSelector.value.trim() !== "") {
            step6.classList.remove('disabled');
            step6.scrollIntoView({ behavior: 'smooth' });
        } else {
            event.preventDefault();
            alert("Please select rush creation time");
            return;
        }
    });
}


function isAnySelected(elements) {
    for (let i = 0; i < elements.length; i++) {
        if (elements[i].classList.contains('selected')) {
            return true;
        }
    }
    return false;
}

function isPetTypeAvailable(selectedPetType, options) {


    // Iterate over each item in the productOptions array
    for (var i = 0; i < options.length; i++) {
        var option = options[i];

        // Check if the current option object contains the selected pet type
        if (selectedPetType in option) {
            var petType = option[selectedPetType];

            // Iterate over each position dynamically
            for (var position in petType) {
                if (petType.hasOwnProperty(position) && typeof petType[position] === 'object') {
                    // Check if the position has the display property set to true
                    if (petType[position].display == true) {
                        return true; // At least one position is not displayed
                    }
                }
            }

            return false; // All positions are displayed
        }
    }

    return false; // Pet type not found
}

const petData = {
    "dog": {
        "Mouth": {
            "display": true,
            "images_and_positions": [{
                "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/close-mouth-no-tongue.png?v=1707226429",
                "alt": "Closed No Tongue",
                "name": "Closed No Tongue",
                "value": "closed-no-tongue"
            }, {
                "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/close-mouth-with-tongue.png?v=1707226429",
                "alt": "Closed With Tongue",
                "name": "Closed With Tongue",
                "value": "closed-with-tongue"
            }, {
                "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/open-mouth-with-tongue.png?v=1707226429",
                "alt": "Open With Tongue",
                "name": "Open With Tongue",
                "value": "open-with-tongue"
            }]
        },
        "Body": {
            "display": false,
            "images_and_positions": [{
                "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/laying.png?v=1707226430",
                "alt": "Laying Down",
                "name": "Laying Down",
                "value": "laying-down"
            }, {
                "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/sitting.png?v=1707226429",
                "alt": "Sitting",
                "name": "Sitting",
                "value": "sitting"
            }, {
                "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/standing.png?v=1707226429",
                "alt": "Standing",
                "name": "Standing",
                "value": "standing"
            }]
        },
        "Tail": {
            "display": false,
            "images_and_positions": [{
                "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/down.png?v=1707226430",
                "alt": "Down",
                "name": "Down",
                "value": "down"
            }, {
                "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/half.png?v=1707226430",
                "alt": "Half",
                "name": "Half",
                "value": "half"
            }, {
                "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/up.png?v=1707226429",
                "alt": "Up",
                "name": "Up",
                "value": "up"
            }, {
                "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/none.png?v=1707226430",
                "alt": "None",
                "name": "None",
                "value": "none"
            }]
        }
    },
    "cat": {
        "Body": {
            "display": false,
            "images_and_positions": [{
                "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/cat-laying.png?v=1707226430",
                "alt": "Laying Down",
                "name": "Laying Down",
                "value": "laying-down"
            }, {
                "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/cat-sitting.png?v=1707226430",
                "alt": "Sitting",
                "name": "Sitting",
                "value": "sitting"
            }]
        },
        "Tail": {
            "display": false,
            "images_and_positions": [{
                "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/cat-tail-yes.png?v=1707226430",
                "alt": "Yes",
                "name": "Yes",
                "value": "Yes"
            }, {
                "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/cat-no-tail.png?v=1707226429",
                "alt": "No Tail",
                "name": "None",
                "value": "none"
            }]
        },
        "Mouth": { "display": false, "images_and_positions": {} }
    },
    "horse": {
        "Body": {
            "display": false,
            "images_and_positions": [{
                "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/horse-laying.png?v=1707226429",
                "alt": "Laying Down",
                "name": "Laying Down",
                "value": "laying-down"
            }, {
                "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/horse-standing.png?v=1707226429",
                "alt": "Standing",
                "name": "Standing",
                "value": "standing"
            }]
        },
        "Tail": {
            "display": false,
            "images_and_positions": [{
                "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/horse-up.png?v=1707226429",
                "alt": "Up",
                "name": "Up",
                "value": "up"
            }, {
                "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/horse-down.png?v=1707226429",
                "alt": "Down",
                "name": "Down",
                "value": "down"
            }, {
                "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/horse-docked-tail.png?v=1707226428",
                "alt": "Bobtail",
                "name": "Bobtail",
                "value": "bobtail"
            }]
        },
        "Mouth": { "display": false, "images_and_positions": {} }
    }
};

function handleEarImages(petName) {
    const earImagesContainer = document.getElementById('earImagesContainer');

    let pet_data = {
        "dog": {
            "ear_positions_heading": "Ear Position",
            "ear_position": {
                "Right": [{
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/Right_Ear_1.png?v=1707731820",
                    "alt": "Up",
                    "value": "up"
                }, {
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/Right_Ear_2.png?v=1707731820",
                    "alt": "Half",
                    "value": "half"
                }, {
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/Right_Ear_3.png?v=1707731820",
                    "alt": "Down",
                    "value": "down"
                }],
                "Left": [{
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/Left_Ear_1.png?v=1707731820",
                    "alt": "Up",
                    "value": "up"
                }, {
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/Left_Ear_2.png?v=1707731820",
                    "alt": "Half",
                    "value": "half"
                }, {
                    "src": "https:\/\/cdn.shopify.com\/s\/files\/1\/0537\/2585\/5916\/files\/Left_Ear_3.png?v=1707731820",
                    "alt": "Down",
                    "value": "down"
                }]
            }
        }, "cat": { "ear_position": {} }, "horse": { "ear_position": {} }
    };

    if (petName) {
        const selectedPetOptions = pet_data[petName];

        const earPositions = selectedPetOptions.ear_position;
        const earPostionLabel = selectedPetOptions.ear_positions_heading;


        if (Object.keys(earPositions).length) {
            // Check if ear positions are available for the selected pet type
            const rightEarPositions = earPositions.Right;
            const leftEarPositions = earPositions.Left;

            if (rightEarPositions && leftEarPositions) {
                // Clear existing content inside the earImagesContainer
                earImagesContainer.innerHTML = '';
                // Create HTML elements for right ear positions
                const earPositionLabel = document.createElement('h3');
                earPositionLabel.textContent = earPostionLabel;
                earPositionLabel.id = 'ear-position-heading';
                earPositionLabel.classList.add("mt-20");

                const earPositionDiv = document.createElement('div');
                earPositionDiv.classList.add("ear-images");

                const rightColDiv = document.createElement('div');
                rightColDiv.classList.add('ear-tab-content');
                rightColDiv.id = 'right-col';
                rightColDiv.style.display = 'none';

                const rightLabel = document.createElement('p');
                rightLabel.classList.add('right-label', 'mt-20');
                rightLabel.textContent = 'Right';

                rightEarPositions.forEach(position => {
                    const label = document.createElement('label');
                    const input = document.createElement('input');
                    const newDiv = document.createElement("div");
                    const imageValue = document.createElement('p');
                    imageValue.textContent = position.value;
                    imageValue.classList.add('imagePositionValue')
                    newDiv.classList.add('ear-label');
                    input.id = 'right-ear-position';
                    input.type = 'radio';
                    input.name = 'properties[_pet_right_ear]';
                    input.tabIndex = -1;
                    input.value = position.value;
                    const img = document.createElement('img');
                    img.src = position.src;
                    img.alt = position.alt;
                    label.addEventListener("click", function () {
                        setEarPosition('right', position.value);
                    });
                    img.setAttribute("aria-label", `${rightLabel.textContent} ${earPostionLabel} ${position.alt}`);
                    img.setAttribute("tabindex", "0");
                    //img.addEventListener("keydown", handlePetEarKeyDown);
                    label.appendChild(input);
                    newDiv.appendChild(img);
                    label.appendChild(newDiv);
                    label.appendChild(imageValue);
                    rightColDiv.appendChild(label);
                });

                // Create HTML elements for left ear positions
                const leftColDiv = document.createElement('div');
                leftColDiv.classList.add('ear-tab-content');
                leftColDiv.id = 'left-col';
                leftColDiv.style.display = 'flex'; // show left by default
                const leftLabel = document.createElement('p');
                leftLabel.classList.add('left-label', 'mt-20');
                leftLabel.textContent = 'Left';

                leftEarPositions.forEach(position => {
                    const label = document.createElement('label');
                    const input = document.createElement('input');
                    const newDiv = document.createElement("div");
                    const imageValue = document.createElement('p');
                    imageValue.textContent = position.value;
                    imageValue.classList.add('imagePositionValue')

                    newDiv.classList.add('ear-label');
                    input.id = 'left-ear-position';
                    input.type = 'radio';
                    input.name = 'properties[_pet_left_ear]';
                    input.value = position.value;
                    input.tabIndex = -1;
                    const img = document.createElement('img');
                    img.src = position.src;
                    img.alt = position.alt;
                    label.addEventListener("click", function () {
                        setEarPosition('left', position.value);
                    });
                    img.setAttribute("aria-label", `${leftLabel.textContent} ${earPostionLabel} ${position.alt}`);
                    img.setAttribute("tabindex", "0");
                    //img.addEventListener("keydown", handlePetEarKeyDown);
                    label.appendChild(input);
                    newDiv.appendChild(img)
                    label.appendChild(newDiv);
                    label.appendChild(imageValue);
                    leftColDiv.appendChild(label);
                });

                // Create toggle wrapper
                const earToggleContainer = document.createElement('div');
                earToggleContainer.classList.add('ear-toggle-select');
                // Create toggle text
                const earToggleLabel = document.createElement('p');
                earToggleLabel.id = 'different-ear-position-label';
                earToggleLabel.textContent = 'Select if each of your pet’s ears are different';
                // Create switch wrapper
                const earSwitchLabel = document.createElement('label');
                earSwitchLabel.classList.add('ear-switch');
                earSwitchLabel.setAttribute("tabindex", "0");
                //earSwitchLabel.addEventListener("keydown", handle_EarToggle_Keydown);

                const earSwitchInput = document.createElement('input');
                earSwitchInput.id = 'different-ear-position';
                earSwitchInput.setAttribute('aria-label', 'different-ear-position');
                earSwitchInput.type = 'checkbox';
                earSwitchInput.onchange = function () {
                    handleEarToggle(this);
                };
                const earSlider = document.createElement('span');
                earSlider.classList.add('ear-slider');
                // Assemble the switch
                earSwitchLabel.appendChild(earSwitchInput);
                earSwitchLabel.appendChild(earSlider);
                // Add text + switch to container
                earToggleContainer.appendChild(earToggleLabel);
                earToggleContainer.appendChild(earSwitchLabel);


                // Create tab buttons container
                const earTabsParent = document.createElement('div');
                earTabsParent.classList.add('earTabs-Parent')
                const earTabs = document.createElement('div');
                earTabs.classList.add('ear-tabs');

                const leftTabBtn = document.createElement('button');
                leftTabBtn.type = 'button';
                leftTabBtn.textContent = 'Left Ear';
                leftTabBtn.className = 'ear-tablink active'; // make left active by default
                leftTabBtn.onclick = function () {
                    openEarTab(event, 'left-col');
                };

                const rightTabBtn = document.createElement('button');
                rightTabBtn.type = 'button';
                rightTabBtn.textContent = 'Right Ear';
                rightTabBtn.className = 'ear-tablink';
                rightTabBtn.onclick = function () {
                    openEarTab(event, 'right-col');
                };

                earTabs.appendChild(leftTabBtn);
                earTabs.appendChild(rightTabBtn);

                earTabsParent.appendChild(earTabs);

                // Append the created elements to earImagesContainer
                earPositionDiv.appendChild(leftColDiv);
                earPositionDiv.appendChild(rightColDiv);
                earImagesContainer.appendChild(earPositionLabel);
                earImagesContainer.appendChild(earToggleContainer);
                earImagesContainer.appendChild(earTabsParent);
                earImagesContainer.appendChild(earPositionDiv);
                earImagesContainer.style.display = 'block';

            } else {
                // Hide the entire "Ear Position" section if ear positions are not available
                earImagesContainer.style.display = 'none';
                earImagesContainer.innerHTML = '';
            }
        }
    } else {
        earImagesContainer.style.display = 'none';
        earImagesContainer.innerHTML = '';
    }
}

const formInput = document.getElementById("formId");
const zipperInput = document.querySelector("#zipperHiddenInput");


function zipperPouchCheckbox(checkbox) {

    let data = {
        "id": 8274293293212,
        "title": "Custom Framed Plush Pet Portrait",
        "handle": "plush-frame",
        "description": "\u003cp\u003e\u003cmeta charset=\"utf-8\"\u003eCherish the bond with your pet in a whole new way with our Custom Framed Plush Pet Portrait! Handcrafted with lifelike detail, this personalized, one-of-a-kind portrait captures the essence of your beloved companion in a plush form, beautifully framed for display. Celebrate the love you share with a timeless piece that will warm your heart every time you see it. You won't believe how lifelike it is.\u003c\/p\u003e",
        "published_at": "2024-10-25T08:14:35-04:00",
        "created_at": "2024-10-03T08:36:56-04:00",
        "vendor": "PawPrint Clones LLC",
        "type": "Plush",
        "tags": ["New_temp", "Plush", "RUSH"],
        "price": 766900,
        "price_min": 766900,
        "price_max": 766900,
        "available": true,
        "price_varies": false,
        "compare_at_price": 1228900,
        "compare_at_price_min": 1228900,
        "compare_at_price_max": 1228900,
        "compare_at_price_varies": false,
        "variants": [{
            "id": 44498369937564,
            "title": "Black",
            "option1": "Black",
            "option2": null,
            "option3": null,
            "sku": "PLUSH-PORTRAIT-BLK",
            "requires_shipping": true,
            "taxable": true,
            "featured_image": null,
            "available": true,
            "name": "Custom Framed Plush Pet Portrait - Black",
            "public_title": "Black",
            "options": ["Black"],
            "price": 766900,
            "weight": 680,
            "compare_at_price": 1228900,
            "inventory_management": null,
            "barcode": "6802581651612",
            "requires_selling_plan": false,
            "selling_plan_allocations": [],
            "quantity_rule": { "min": 1, "max": null, "increment": 1 }
        }, {
            "id": 44498369970332,
            "title": "White",
            "option1": "White",
            "option2": null,
            "option3": null,
            "sku": "PLUSH-PORTRAIT-WHT",
            "requires_shipping": true,
            "taxable": true,
            "featured_image": null,
            "available": true,
            "name": "Custom Framed Plush Pet Portrait - White",
            "public_title": "White",
            "options": ["White"],
            "price": 766900,
            "weight": 680,
            "compare_at_price": 1228900,
            "inventory_management": null,
            "barcode": "",
            "requires_selling_plan": false,
            "selling_plan_allocations": [],
            "quantity_rule": { "min": 1, "max": null, "increment": 1 }
        }, {
            "id": 44498370003100,
            "title": "Gold",
            "option1": "Gold",
            "option2": null,
            "option3": null,
            "sku": "PLUSH-PORTRAIT-GLD",
            "requires_shipping": true,
            "taxable": true,
            "featured_image": null,
            "available": true,
            "name": "Custom Framed Plush Pet Portrait - Gold",
            "public_title": "Gold",
            "options": ["Gold"],
            "price": 766900,
            "weight": 680,
            "compare_at_price": 1228900,
            "inventory_management": null,
            "barcode": "",
            "requires_selling_plan": false,
            "selling_plan_allocations": [],
            "quantity_rule": { "min": 1, "max": null, "increment": 1 }
        }, {
            "id": 44498370035868,
            "title": "Bronze",
            "option1": "Bronze",
            "option2": null,
            "option3": null,
            "sku": "PLUSH-PORTRAIT-BRZ",
            "requires_shipping": true,
            "taxable": true,
            "featured_image": null,
            "available": true,
            "name": "Custom Framed Plush Pet Portrait - Bronze",
            "public_title": "Bronze",
            "options": ["Bronze"],
            "price": 766900,
            "weight": 680,
            "compare_at_price": 1228900,
            "inventory_management": null,
            "barcode": "",
            "requires_selling_plan": false,
            "selling_plan_allocations": [],
            "quantity_rule": { "min": 1, "max": null, "increment": 1 }
        }],
        "images": ["\/\/cuddleclones.com\/cdn\/shop\/files\/PlushFrame_comparison_Dog.jpg?v=1752155612", "\/\/cuddleclones.com\/cdn\/shop\/files\/TwinningCalloutGraphic_plushframe.png?v=1752155620", "\/\/cuddleclones.com\/cdn\/shop\/files\/USPCalloutGraphics_Plushportrait.jpg?v=1752155622", "\/\/cuddleclones.com\/cdn\/shop\/files\/PerfectGiftGraphic_plsuhclone.jpg?v=1752155624", "\/\/cuddleclones.com\/cdn\/shop\/files\/plushportrait_7.png?v=1752155630", "\/\/cuddleclones.com\/cdn\/shop\/files\/plushportrait_5.png?v=1752155646", "\/\/cuddleclones.com\/cdn\/shop\/files\/plushportrait_4.png?v=1752155679", "\/\/cuddleclones.com\/cdn\/shop\/files\/plushportrait_10.png?v=1752155692", "\/\/cuddleclones.com\/cdn\/shop\/files\/plushportrait_12.png?v=1752155700", "\/\/cuddleclones.com\/cdn\/shop\/files\/plushportrait_13.png?v=1752155705", "\/\/cuddleclones.com\/cdn\/shop\/files\/plushportrait_14.png?v=1752155711", "\/\/cuddleclones.com\/cdn\/shop\/files\/plushportrait_15.png?v=1752155718"],
        "featured_image": "\/\/cuddleclones.com\/cdn\/shop\/files\/PlushFrame_comparison_Dog.jpg?v=1752155612",
        "options": ["frame options"],
        "media": [{
            "alt": null,
            "id": 32266076979356,
            "position": 1,
            "preview_image": {
                "aspect_ratio": 1.0,
                "height": 1000,
                "width": 1000,
                "src": "\/\/cuddleclones.com\/cdn\/shop\/files\/PlushFrame_comparison_Dog.jpg?v=1752155612"
            },
            "aspect_ratio": 1.0,
            "height": 1000,
            "media_type": "image",
            "src": "\/\/cuddleclones.com\/cdn\/shop\/files\/PlushFrame_comparison_Dog.jpg?v=1752155612",
            "width": 1000
        }, {
            "alt": null,
            "id": 32266084778140,
            "position": 2,
            "preview_image": {
                "aspect_ratio": 1.0,
                "height": 1000,
                "width": 1000,
                "src": "\/\/cuddleclones.com\/cdn\/shop\/files\/TwinningCalloutGraphic_plushframe.png?v=1752155620"
            },
            "aspect_ratio": 1.0,
            "height": 1000,
            "media_type": "image",
            "src": "\/\/cuddleclones.com\/cdn\/shop\/files\/TwinningCalloutGraphic_plushframe.png?v=1752155620",
            "width": 1000
        }, {
            "alt": null,
            "id": 32266099884188,
            "position": 3,
            "preview_image": {
                "aspect_ratio": 1.0,
                "height": 1000,
                "width": 1000,
                "src": "\/\/cuddleclones.com\/cdn\/shop\/files\/USPCalloutGraphics_Plushportrait.jpg?v=1752155622"
            },
            "aspect_ratio": 1.0,
            "height": 1000,
            "media_type": "image",
            "src": "\/\/cuddleclones.com\/cdn\/shop\/files\/USPCalloutGraphics_Plushportrait.jpg?v=1752155622",
            "width": 1000
        }, {
            "alt": null,
            "id": 32266085138588,
            "position": 4,
            "preview_image": {
                "aspect_ratio": 1.0,
                "height": 1000,
                "width": 1000,
                "src": "\/\/cuddleclones.com\/cdn\/shop\/files\/PerfectGiftGraphic_plsuhclone.jpg?v=1752155624"
            },
            "aspect_ratio": 1.0,
            "height": 1000,
            "media_type": "image",
            "src": "\/\/cuddleclones.com\/cdn\/shop\/files\/PerfectGiftGraphic_plsuhclone.jpg?v=1752155624",
            "width": 1000
        }, {
            "alt": null,
            "id": 32254848467100,
            "position": 5,
            "preview_image": {
                "aspect_ratio": 1.0,
                "height": 1000,
                "width": 1000,
                "src": "\/\/cuddleclones.com\/cdn\/shop\/files\/plushportrait_7.png?v=1752155630"
            },
            "aspect_ratio": 1.0,
            "height": 1000,
            "media_type": "image",
            "src": "\/\/cuddleclones.com\/cdn\/shop\/files\/plushportrait_7.png?v=1752155630",
            "width": 1000
        }, {
            "alt": null,
            "id": 32254824415388,
            "position": 6,
            "preview_image": {
                "aspect_ratio": 1.0,
                "height": 1000,
                "width": 1000,
                "src": "\/\/cuddleclones.com\/cdn\/shop\/files\/plushportrait_5.png?v=1752155646"
            },
            "aspect_ratio": 1.0,
            "height": 1000,
            "media_type": "image",
            "src": "\/\/cuddleclones.com\/cdn\/shop\/files\/plushportrait_5.png?v=1752155646",
            "width": 1000
        }, {
            "alt": null,
            "id": 32254818877596,
            "position": 7,
            "preview_image": {
                "aspect_ratio": 1.0,
                "height": 1000,
                "width": 1000,
                "src": "\/\/cuddleclones.com\/cdn\/shop\/files\/plushportrait_4.png?v=1752155679"
            },
            "aspect_ratio": 1.0,
            "height": 1000,
            "media_type": "image",
            "src": "\/\/cuddleclones.com\/cdn\/shop\/files\/plushportrait_4.png?v=1752155679",
            "width": 1000
        }, {
            "alt": null,
            "id": 32254867341468,
            "position": 8,
            "preview_image": {
                "aspect_ratio": 1.0,
                "height": 1000,
                "width": 1000,
                "src": "\/\/cuddleclones.com\/cdn\/shop\/files\/plushportrait_10.png?v=1752155692"
            },
            "aspect_ratio": 1.0,
            "height": 1000,
            "media_type": "image",
            "src": "\/\/cuddleclones.com\/cdn\/shop\/files\/plushportrait_10.png?v=1752155692",
            "width": 1000
        }, {
            "alt": null,
            "id": 32254873567388,
            "position": 9,
            "preview_image": {
                "aspect_ratio": 1.0,
                "height": 1000,
                "width": 1000,
                "src": "\/\/cuddleclones.com\/cdn\/shop\/files\/plushportrait_12.png?v=1752155700"
            },
            "aspect_ratio": 1.0,
            "height": 1000,
            "media_type": "image",
            "src": "\/\/cuddleclones.com\/cdn\/shop\/files\/plushportrait_12.png?v=1752155700",
            "width": 1000
        }, {
            "alt": null,
            "id": 32254878351516,
            "position": 10,
            "preview_image": {
                "aspect_ratio": 1.0,
                "height": 1000,
                "width": 1000,
                "src": "\/\/cuddleclones.com\/cdn\/shop\/files\/plushportrait_13.png?v=1752155705"
            },
            "aspect_ratio": 1.0,
            "height": 1000,
            "media_type": "image",
            "src": "\/\/cuddleclones.com\/cdn\/shop\/files\/plushportrait_13.png?v=1752155705",
            "width": 1000
        }, {
            "alt": null,
            "id": 32254884511900,
            "position": 11,
            "preview_image": {
                "aspect_ratio": 1.0,
                "height": 1000,
                "width": 1000,
                "src": "\/\/cuddleclones.com\/cdn\/shop\/files\/plushportrait_14.png?v=1752155711"
            },
            "aspect_ratio": 1.0,
            "height": 1000,
            "media_type": "image",
            "src": "\/\/cuddleclones.com\/cdn\/shop\/files\/plushportrait_14.png?v=1752155711",
            "width": 1000
        }, {
            "alt": null,
            "id": 32254888575132,
            "position": 12,
            "preview_image": {
                "aspect_ratio": 1.0,
                "height": 1000,
                "width": 1000,
                "src": "\/\/cuddleclones.com\/cdn\/shop\/files\/plushportrait_15.png?v=1752155718"
            },
            "aspect_ratio": 1.0,
            "height": 1000,
            "media_type": "image",
            "src": "\/\/cuddleclones.com\/cdn\/shop\/files\/plushportrait_15.png?v=1752155718",
            "width": 1000
        }],
        "requires_selling_plan": false,
        "selling_plan_groups": [],
        "content": "\u003cp\u003e\u003cmeta charset=\"utf-8\"\u003eCherish the bond with your pet in a whole new way with our Custom Framed Plush Pet Portrait! Handcrafted with lifelike detail, this personalized, one-of-a-kind portrait captures the essence of your beloved companion in a plush form, beautifully framed for display. Celebrate the love you share with a timeless piece that will warm your heart every time you see it. You won't believe how lifelike it is.\u003c\/p\u003e"
    };

    if (checkbox.checked) {
        zipperInput.value = true;
        // If the checkbox is checked and the title is included, set the form input value to the corresponding ID
        formInput.value = data.variants.find(variant => variant.title === "Included").id;
    } else {
        zipperInput.value = false;

        // If the checkbox is not checked, set a default value
        formInput.value = data.variants.find(variant => variant.title === "Not Included").id;
    }
}

let products = [];

let originalUniqueKey = document.querySelector("#originalUniqueKey").value;
let isPresentFreeProduct = false;


$('#add_to_cart').on('click', function (event) {
    event.preventDefault();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const hasVariantParam = urlParams.has('variant');

    // 添加标志变量来跟踪$.post()是否被执行
    let cartAddExecuted = false;

    if (hasVariantParam) {
        const storedDataString = sessionStorage.getItem('customizerFormData');
        if (storedDataString) {
            const retrievedFormData = JSON.parse(storedDataString);

            // 将JavaScript对象转换为URL编码字符串，保持与theme.js中$(data).serialize()一致
            var serializedData = $.param(retrievedFormData);


            var params = {
                url: window.router + '/cart/add.js',
                data: serializedData,  // 使用序列化后的字符串
                dataType: 'json'
            };

            // 标记$.post()已被执行
            cartAddExecuted = true;
            
            // 显示按钮加载状态
            const $addToCartButton = $('#add_to_cart');
            const originalText = $addToCartButton.text();
            $addToCartButton.data('original-text', originalText);
            $addToCartButton.prop('disabled', true);
            $addToCartButton.addClass('loading');
            $addToCartButton.html('<span class="loading-spinner"></span>Adding to cart...');
            
            $.post(params)

            sessionStorage.removeItem('customizerFormData');
        }
    }

    // 获取表单数据
    const formData = $('#plush_customizer_form').serializeArray();


    console.log('表单序列化数据:', formData);

    // 创建获取表单字段值的函数
    function getFormValue(formData, fieldName) {
        const item = formData.find(item => item.name === fieldName);
        return item ? item.value : null;
    }

    // 获取特定字段的值
    const pet_method = getFormValue(formData, "properties[_pet_type]");
    const pet_name = getFormValue(formData, "properties[_pet_name]");
    const contact_email = getFormValue(formData, "properties[contact_email]");
    const contact_wechat = getFormValue(formData, "properties[contact_wechat]");
    const contact_phone = getFormValue(formData, "properties[contact_phone]");
    const contact_country_code = getFormValue(formData, "properties[contact_country_code]");
    const pet_age = getFormValue(formData, "properties[_pet_age]");
    const pet_variety = getFormValue(formData, "properties[_pet_breed_specie]");

    // 使用上传后的服务器URL替换本地数据
    const pet_image = uploadedImagesData.petImages; // 宠物图片数组，包含URL和描述
    const coat_color_image = uploadedImagesData.furColorImage; // 毛色图片URL
    const hair_length_image = uploadedImagesData.furLengthImage; // 毛长图片URL
    const pet_age_image = uploadedImagesData.petAgeImage; // 年龄图片URL

    const left_eye = getFormValue(formData, "properties[_pet_left_eye]");
    const right_eye = getFormValue(formData, "properties[_pet_right_eye]");
    const photo_frame = getFormValue(formData, "properties[frame_option]");
    const background = getFormValue(formData, "properties[background_option]");
    const buy_num = getFormValue(formData, "quantity");



    fetch('https://api.paw-print.cn/index.php/api/index/customize', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            server: true,
        },
        body: JSON.stringify({
            pet_method: pet_method,
            pet_name: pet_name,
            email: contact_email,
            wechat: contact_wechat,
            mobile: "+" + contact_country_code + " " + contact_phone,
            pet_age: pet_age,
            pet_variety: pet_variety,
            pet_image: pet_image,
            coat_color_image: coat_color_image,
            hair_length_image: hair_length_image,
            pet_age_image: pet_age_image,
            left_eye: left_eye,
            right_eye: right_eye,
            photo_frame: photo_frame,
            background: background,
            buy_num: buy_num
        })
    })
        .then(response => {
            return response.json(); // 关键：读取 JSON 响应内容

        }).then(data => {
            if (data.code === 1) {
                // 提交成功，跳转到结果页面
                // 获取当前语言路径前缀
                function getCurrentLanguagePrefix() {
                    var pathSegments = window.location.pathname.split('/').filter(function (x) { return x; });
                    // 检查第一个路径段是否是语言代码（如 zh-cn, en 等）
                    if (pathSegments.length > 0) {
                        var firstSegment = pathSegments[0].toLowerCase();
                        // 常见的语言代码格式：zh-cn, en, fr, de 等
                        if (firstSegment.match(/^[a-z]{2}(-[a-z]{2})?$/)) {
                            return '/' + firstSegment;
                        }
                    }
                    return '';
                }

                var languagePrefix = getCurrentLanguagePrefix();

                // 根据$.post()执行情况决定跳转逻辑
                if (cartAddExecuted) {
                    // 如果执行了$.post()逻辑，则进行延时且不保留页面的跳转
                    setTimeout(() => {
                        // 恢复按钮状态
                        const $addToCartButton = $('#add_to_cart');
                        const originalText = $addToCartButton.data('original-text') || 'Submit';
                        $addToCartButton.prop('disabled', false);
                        $addToCartButton.removeClass('loading');
                        $addToCartButton.html(originalText);
                        
                        window.location.replace(hasVariantParam ? languagePrefix + "/pages/submit-successfully#variant" : languagePrefix + "/pages/submit-successfully");
                    }, 1500);
                } else {
                    // 反之正常跳转
                    window.location.href = hasVariantParam ? languagePrefix + "/pages/submit-successfully#variant" : languagePrefix + "/pages/submit-successfully";
                }
            } else {
                console.error('提交失败:', data.msg);
            }
        })
        .catch(error => {
            console.error('提交失败:', error);
        });




});

if (products) {
    for (let i = 0; i < products.length; i++) {
        var product = products[i];
        var productName = product.name;
        let mainCheckboxes = document.querySelectorAll(`.${productName}_checkbox`);

        // dependency Logic
        if (product.detail.dependency?.length > 0) {
            product.detail.dependency.forEach(function (item) {
                const itemName = item.product_name;
                const itemMessage = item.message;
                const itemCheckboxes = document.querySelectorAll(`.${itemName}_checkbox`);

                mainCheckboxes.forEach(function (mainCheckbox) {
                    mainCheckbox.addEventListener('change', function () {
                        if (mainCheckbox.checked) {
                            itemCheckboxes.forEach(function (itemCheckbox) {
                                if (!itemCheckbox.checked) {
                                    itemCheckbox.checked = true;
                                    alert(itemMessage);
                                }
                            });
                        }
                    });
                });
                // if user tries to uncheck the dependent product then forcefully check the dependent product if main product is checked
                itemCheckboxes.forEach(function (itemCheckbox) {
                    itemCheckbox.addEventListener('change', function () {
                        mainCheckboxes.forEach(function (mainCheckbox) {
                            if (mainCheckbox.checked && !itemCheckbox.checked) {
                                itemCheckbox.checked = true;
                            }
                        });
                    })
                })
            });
        }
        // Incompatibility Logic
        if (product.detail.incompatibility?.length > 0) {
            product.detail.incompatibility.forEach(function (item) {
                const incompatibleName = item.product_name;
                const incompatibilityMessage = item.message;
                const incompatibleCheckboxes = document.querySelectorAll(`.${incompatibleName}_checkbox`);

                mainCheckboxes.forEach(function (mainCheckbox) {
                    mainCheckbox.addEventListener('change', function () {
                        if (mainCheckbox.checked) {
                            incompatibleCheckboxes.forEach(function (incompatibleCheckbox) {
                                if (incompatibleCheckbox.checked) {
                                    // Uncheck the incompatible addon
                                    incompatibleCheckbox.checked = false;
                                    alert(incompatibilityMessage);
                                }
                            });
                        }
                    });
                });
            });
        }
    }
}


function addFreeProduct() {

    var values = {};
    $.each($("form").serializeArray(), function (i, field) {
        values[field.name] = field.value;
    });

    let product_id = $("#free_product_div").data("product_id");
    let mainUrl = "";
    let hostUrl = window.location.host;
    const currentUrl = window.location.href;
    const baseUrl = currentUrl.replace(/\/[^/]*$/, "/");
    let nativeOptionsKeys = [];
    let freeInputKey = document.querySelector("#freeUniqueId");

    // check the host url for end point
    if (hostUrl == "cuddleclones-dev.myshopify.com") {
        mainUrl = "https://oms-dev.cuddleclones.com/";
    } else if (hostUrl == "cuddleclones.com") {
        mainUrl = "https://oms.cuddleclones.com/";
    } else {
        mainUrl = "https://oms-uat.cuddleclones.com/";
    }
    const endpoint = `${mainUrl}shopify_api/get_product_metafields?product_id=${product_id}`;

    // product _id in metafiled ajax
    let product_check = false;
    let variant_check = false;
    let offer_all_product = false;
    let free_product_id = "";
    let metafieldsUrl = "";
    let endpoint2 = "";

    $.ajax({
        url: endpoint,
        method: "GET",
        headers: {
            'api-token': omsDetails[0].api_token
        },
        success: function (response) {

            const productId = response;
            const variant_id = response["id"];
            $.each(productId.response.metafields, (index, value) => {
                if (value.key == "product_id") {
                    var json_obj = JSON.parse(value.value);
                    free_product_id = json_obj;
                }

                if (free_product_id) {
                    $(".freeProductSection").show();
                    var freeProductDiv =
                        document.getElementById("free_product_div");
                    if (freeProductDiv) {
                        freeProductDiv.style.visibility = "visible";
                    }
                    $("#free_product_title").append("");
                    const meta_product_id = free_product_id;

                    // get handle of free product
                    endpoint2 = `${mainUrl}shopify_api/get_product?product_id=${meta_product_id}`;
                    metafieldsUrl = `${mainUrl}shopify_api/get_product_metafields?product_id=${meta_product_id}`;
                } else {
                    $(".freeProductSection").hide();
                }
            });
            if (free_product_id) {
                $.ajax({
                    url: endpoint2,
                    method: "GET",
                    headers: {
                        'api-token': omsDetails[0].api_token
                    },
                    success: function (response) {
                        $(".freeProductVariants").val(
                            JSON.stringify(response.response.product.variants)
                        );
                        $(".productName").html("");
                        $(".productComparePrice").html("");
                        const data = response;
                        const title = data.response.product.title;
                        const imageUrl = data.response.product.image.src;
                        const compareAtPrice =
                            data.response.product.variants[0].compare_at_price;
                        $(".productName").append(title);
                        $(".productImage").attr("src", imageUrl);
                        $(".productComparePrice").append(`$${compareAtPrice}`);
                    },
                });
                $.ajax({
                    url: metafieldsUrl,
                    method: "GET",
                    headers: {
                        'api-token': omsDetails[0].api_token
                    },
                    success: function (response) {
                        metafieldsData = response.response.metafields;
                        $(".productReviews").html("");
                        $(".variantsContainer").html("");

                        displayMetafields(metafieldsData);
                        $(".freeProductKeys").val(JSON.stringify(nativeOptionsKeys));
                    },
                    error: function (error) {
                        console.log("Error:", error);
                    },
                });
            } else {
                window.location.href = "https://cuddleclones.com/cart";
            }
        },
    });

    let metafieldsData = null;

    function displayMetafields(metafields) {
        let customOptions = [];
        let nativeValues = [];
        freeInputKey.value = values["properties[_original_unique_key]"];
        metafields.forEach((metafield) => {
            if (metafield.key === "badge") {
                let reviews = metafield.value;
                $(".productReviews").append(reviews);
            } else if (metafield.key === "custom_options") {

                customOptions = JSON.parse(metafield.value);

            } else if (metafield.key === "native_options") {
                nativeValues = JSON.parse(metafield.value);
                nativeOption = JSON.parse(metafield.value);
            }
        });
        displayCustomOptions(customOptions);
        displayNativeOptions(nativeValues);


        // end free product code

    }

    function displayNativeOptions(nativeValues) {
        for (var key in nativeValues) {
            if (nativeValues.hasOwnProperty(key)) {
                let option = nativeValues[key];

                nativeOptionsKeys.push(option.name);

                if (option.type === "dropdown") {
                    const hiddenInput = document.createElement("input");
                    hiddenInput.type = "hidden";
                    hiddenInput.name = `properties[${option.name}]`;
                    hiddenInput.classList.add(`${option.name}HiddenInput`);
                    hiddenInput.value = option.options[0].value;

                    const div = document.createElement("div");
                    div.classList.add(
                        "selector-wrapper-free-product",
                        option.name
                    );

                    // Create the label element
                    const label = document.createElement("label");
                    label.setAttribute("for", `data-variant-option-`);
                    label.setAttribute(
                        "data-variant-option-name",
                        option.heading
                    );
                    label.setAttribute(
                        "data-variant-option-choose-name",
                        option.heading
                    );
                    label.textContent = option.heading;
                    div.appendChild(label);

                    // Create the span element
                    const span = document.createElement("span");
                    span.classList.add("selectFreeVariant");
                    span.setAttribute("data-dropdown-form-style", "");
                    div.appendChild(span);

                    // Create the select element
                    const select = document.createElement("select");
                    select.classList.add(
                        "single-option-selector",
                        "nativeLengthOption"
                    );
                    select.id = `data-variant-option-`;
                    select.setAttribute(
                        "onchange",
                        `handleNativeAction("${option.heading}", this, "", "dropdown")`
                    );
                    // select.setAttribute('onchange', `handleNativeAction('${option.heading}', this, '', '${option.name}');`);
                    select.setAttribute("data-variant-option", "");

                    select.style.color = "black";
                    span.appendChild(select);

                    // Create and append the default option
                    const defaultOption = document.createElement("option");
                    defaultOption.value = option.options[0].value; // Set default value to the first option
                    defaultOption.selected = true;
                    defaultOption.setAttribute(
                        "data-variant-option-value-wrapper",
                        ""
                    );
                    defaultOption.setAttribute("data-variant-option-value", "");
                    defaultOption.setAttribute(
                        "data-variant-option-value-index",
                        ""
                    );
                    defaultOption.innerHTML = option.options[0].name; // Display the name of the first option
                    select.appendChild(defaultOption);

                    // Create the options
                    option.options.forEach((value, index) => {
                        if (value.display && index !== 0) {
                            const optionElement = document.createElement("option");
                            optionElement.value = value.value;
                            // if (
                            //   selectedVariant &&
                            //   option.selected_value == value.value
                            // ) {
                            //   optionElement.selected = true;
                            // }
                            optionElement.setAttribute(
                                "data-variant-option-value-wrapper",
                                ""
                            );
                            optionElement.setAttribute(
                                "data-variant-option-value",
                                ""
                            );
                            optionElement.setAttribute(
                                "data-variant-option-value-index",
                                ""
                            );
                            optionElement.textContent = value.name;
                            select.appendChild(optionElement);
                        }
                    });

                    // Append the div to a target container
                    const targetContainer = $(".variantsContainer");
                    targetContainer.append(hiddenInput);
                    targetContainer.append(div);
                } else if (option.type === "button") {
                    const hiddenInput = document.createElement("input");
                    hiddenInput.type = "hidden";
                    hiddenInput.name = `properties[${option.name}]`;
                    hiddenInput.classList.add(`${option.name}HiddenInput`);
                    hiddenInput.value = option.options[0].value;

                    if (option.shape === "circle") {
                        // Create the main div element
                        const div = document.createElement("div");
                        div.classList.add("selector-wrapper-free-product");

                        // Create the label element
                        const label = document.createElement("label");
                        label.setAttribute("for", `data-variant-option-`);
                        label.setAttribute(
                            "data-variant-option-name",
                            option.heading
                        );
                        label.setAttribute(
                            "data-variant-option-choose-name",
                            option.heading
                        );
                        label.textContent = option.heading;
                        div.appendChild(label);

                        // Create the span element
                        const span = document.createElement("span");
                        div.appendChild(span);

                        // Loop through the options and create buttons
                        option.options.forEach((value, index) => {
                            if (value.display) {
                                const headingWithHyphen = option.heading.replace(
                                    /\s+/g,
                                    "_"
                                );
                                const button = document.createElement("button");
                                button.type = "button";
                                button.classList.add(
                                    "rounded-button",
                                    `${headingWithHyphen}CircleButton`
                                );
                                button.setAttribute(
                                    "onclick",
                                    `handleNativeAction('${option.heading}', this, '.rounded-button', 'button', 'Circle')`
                                );
                                button.textContent = value.name;
                                if (index === 0) {
                                    button.classList.add("selected"); // Add a class for selected state
                                    button.style.border = "2px solid rgb(84, 97, 200)"; // Apply specific style
                                }
                                span.appendChild(button);
                            }
                        });

                        const targetContainer = $(".variantsContainer");
                        targetContainer.append(hiddenInput);
                        targetContainer.append(div);
                    } else if (option.shape === "rectangle") {
                        // Create the main div element
                        const div = document.createElement("div");
                        div.classList.add(
                            "selector-wrapper-free-product",
                            "defaultNumberOfOptions"
                        );

                        // Create the label element
                        const label = document.createElement("label");
                        label.setAttribute("for", `data-variant-option-`);
                        label.setAttribute(
                            "data-variant-option-name",
                            option.heading
                        );
                        label.setAttribute(
                            "data-variant-option-choose-name",
                            option.heading
                        );
                        label.textContent = option.heading;
                        div.appendChild(label);

                        // Create the span element
                        const span = document.createElement("span");
                        div.appendChild(span);

                        // Loop through the options and create buttons
                        option.options.forEach((value, index) => {
                            if (value.display) {
                                const headingWithHyphen = option.heading.replace(
                                    /\s+/g,
                                    "_"
                                );
                                const button = document.createElement("button");
                                button.type = "button";
                                button.classList.add(
                                    "rectangle-button",
                                    `${headingWithHyphen}RectangleButton`
                                );
                                button.setAttribute(
                                    "onclick",
                                    `handleNativeAction('${option.heading}', this, '.rectangle-button', 'button', 'Rectangle')`
                                );
                                button.textContent = value.name;
                                if (index === 0) {
                                    button.classList.add("selected"); // Add a class for selected state
                                    button.style.border = "2px solid rgb(84, 97, 200)"; // Apply specific style
                                }
                                span.appendChild(button);
                            }
                        });

                        // Append the hidden input and the divs to a target container
                        const targetContainer = $(".variantsContainer");
                        targetContainer.append(hiddenInput);
                        targetContainer.append(div);
                    }
                } else if (option.type === "swatches") {
                    const hiddenInput = document.createElement("input");
                    hiddenInput.type = "hidden";
                    hiddenInput.name = `properties[${option.name}]`;
                    hiddenInput.classList.add(`${option.name}HiddenInput`);
                    hiddenInput.value = option.options[0].name;

                    // Create the main swatches-select div element
                    const swatchesSelectDiv = document.createElement("div");
                    swatchesSelectDiv.classList.add("swatches-select");
                    swatchesSelectDiv.style.marginBottom = "10px";

                    // Create the swatches-label div element
                    const swatchesLabelDiv = document.createElement("div");
                    swatchesLabelDiv.classList.add(
                        "swatches-label-free-product"
                    );

                    // Create the label element
                    const label = document.createElement("label");
                    label.setAttribute("for", `data-variant-option-`);
                    label.setAttribute(
                        "data-variant-option-name",
                        option.heading
                    );
                    label.setAttribute(
                        "data-variant-option-choose-name",
                        option.heading
                    );
                    label.innerHTML = `${option.heading}: <span id="${option.heading}-selected-swatches">${option.options[0].name}</span>`;
                    swatchesLabelDiv.appendChild(label);

                    // Append the swatches-label div to the swatches-select div
                    swatchesSelectDiv.appendChild(swatchesLabelDiv);

                    // Create the inner div for the radio buttons and images
                    const innerDiv = document.createElement("div");
                    innerDiv.style.marginBottom = "15px";
                    innerDiv.style.marginLeft = "25px";

                    // Loop through the options and create radio buttons with images
                    option.options.forEach((value, index) => {
                        if (value.display) {
                            const label = document.createElement("label");
                            label.style.marginRight = "10px";

                            const radioInput = document.createElement("input");
                            radioInput.type = "radio";
                            radioInput.name = option.name;
                            radioInput.value = value.name;
                            radioInput.style.width = "0px";
                            label.appendChild(radioInput);

                            if (index === 0) {
                                radioInput.checked = true;
                            }

                            const img = document.createElement("img");
                            img.src = value.image;
                            img.alt = value.name;
                            img.title = value.name;
                            img.width = 50;
                            img.height = 50;
                            img.onclick = function () {
                                handleNativeAction(
                                    option.heading,
                                    value.name,
                                    "",
                                    "swatches"
                                );
                            };
                            label.appendChild(img);

                            innerDiv.appendChild(label);
                        }
                    });

                    // Append the inner div to the swatches-select div
                    swatchesSelectDiv.appendChild(innerDiv);

                    // Append the hidden input and the swatches-select div to a target container
                    const targetContainer = $(".variantsContainer");
                    targetContainer.append(hiddenInput);
                    targetContainer.append(swatchesSelectDiv);
                }
            }
        }

    }

    function displayCustomOptions(customOptions) {
        for (var key in customOptions) {
            let option = customOptions[key];

            if (option.display && option.type === "dropdown") {
                // Create the hidden input element
                let hiddenInput = document.createElement("input");
                hiddenInput.type = "hidden";
                hiddenInput.name = `properties[${option.heading}]`;
                hiddenInput.value = option.options[0].value;
                hiddenInput.className = `${option.name}HiddenInput`;

                // Create the selector wrapper div
                let selectorWrapper = document.createElement("div");
                selectorWrapper.className = "selector-wrapper-free-product";

                // Create the label element
                let label = document.createElement("label");
                label.setAttribute("for", `data-variant-option`);
                label.setAttribute("data-variant-option-name", option.name);
                label.setAttribute(
                    "data-variant-option-choose-name",
                    option.name
                );
                label.innerHTML = option.heading;

                // Create the span element
                let span = document.createElement("span");
                span.className = "selectFreeVariant";
                span.setAttribute("data-dropdown-form-style", "");

                // Create the select element
                let select = document.createElement("select");
                select.className = "single-option-selector";
                select.setAttribute(
                    "onchange",
                    `getSelectedValue('${option.name}', this, '${option.heading}');`
                );
                select.id = `data-variant-option`;
                select.setAttribute("data-variant-option", "");
                select.setAttribute("data-variant-option-index", "");
                select.style.color = "black";

                // Create and append the default option
                const defaultOption = document.createElement("option");
                defaultOption.value = option.options[0].value; // Set default value to the first option
                defaultOption.selected = true;
                defaultOption.setAttribute(
                    "data-variant-option-value-wrapper",
                    ""
                );
                defaultOption.setAttribute("data-variant-option-value", "");
                defaultOption.setAttribute(
                    "data-variant-option-value-index",
                    ""
                );
                defaultOption.innerHTML = option.options[0].name; // Display the name of the first option

                select.appendChild(defaultOption);

                // Create and append the other options
                option.options.forEach((value, idx) => {
                    if (idx !== 0) {
                        // Skip the first option as it's already added
                        const optionElement = document.createElement("option");
                        optionElement.value = value.value;
                        if (option.selected_value === value.value) {
                            optionElement.selected = true;
                            hiddenInput.value = value.value; // Update hidden input with selected value
                        }
                        optionElement.setAttribute(
                            "data-variant-option-value-wrapper",
                            ""
                        );
                        optionElement.setAttribute(
                            "data-variant-option-value",
                            ""
                        );
                        optionElement.setAttribute(
                            "data-variant-option-value-index",
                            ""
                        );
                        optionElement.innerHTML = value.name;

                        select.appendChild(optionElement);
                    }
                });

                // Append the select element to the span
                span.appendChild(select);

                // Append the label and span to the selector wrapper
                selectorWrapper.appendChild(label);
                selectorWrapper.appendChild(span);

                // Append the hidden input and selector wrapper to the desired parent element
                const targetContainer = $(".variantsContainer");
                targetContainer.append(hiddenInput);
                targetContainer.append(selectorWrapper);
            } else if (option.display && option.type === "swatches") {
                // Create the hidden input element
                let hiddenInput = document.createElement("input");
                hiddenInput.type = "hidden";
                hiddenInput.name = `properties[${option.heading}]`;
                hiddenInput.className = `${option.name}HiddenInput`;
                hiddenInput.value = option.options[0].name;

                // Create the main wrapper div
                let mainWrapper = document.createElement("div");
                mainWrapper.className = "swatches-select-free-product";
                mainWrapper.style.marginBottom = "10px";

                // Create the label wrapper div
                let labelWrapper = document.createElement("div");
                labelWrapper.className = "swatches-label-free-product";

                // Create the label element
                let label = document.createElement("label");
                label.setAttribute("for", `data-variant-option-`);
                label.setAttribute("data-variant-option-name", option.name);
                label.setAttribute(
                    "data-variant-option-choose-name",
                    option.name
                );

                label.innerHTML = `${option.heading}: <span id="${option.name}-selected-swatches">${option.options[0].name}</span>`;

                // Append the label to the label wrapper
                labelWrapper.appendChild(label);

                // Create the inner wrapper div
                let innerWrapper = document.createElement("div");
                innerWrapper.classList.add("free-swatches");
                innerWrapper.style.marginBottom = "15px";
                innerWrapper.style.marginLeft = "25px";

                // Create the radio buttons and images
                option.options.forEach((value, index) => {
                    let labelElement = document.createElement("label");
                    labelElement.style.marginRight = "10px";

                    let radioInput = document.createElement("input");
                    radioInput.classList.add("customRadioInputs");
                    radioInput.id = option.name;
                    radioInput.type = "radio";
                    radioInput.name = option.name;
                    radioInput.value = value.name;

                    if (index === 0) {
                        radioInput.checked = true;
                    }

                    let image = document.createElement("img");
                    image.src = value.image;
                    image.alt = value.name;
                    image.title = value.name;
                    image.classList.add("swatchesImage")
                    image.width = 50;
                    image.height = 50;
                    image.setAttribute(
                        "onclick",
                        `selectBackground('${option.name}', '${value.name}', '${option.heading}')`
                    );

                    // Append the radio input and image to the label element
                    labelElement.appendChild(radioInput);
                    labelElement.appendChild(image);

                    // Append the label element to the inner wrapper
                    innerWrapper.appendChild(labelElement);
                });

                // Append the label wrapper and inner wrapper to the main wrapper
                mainWrapper.appendChild(labelWrapper);
                mainWrapper.appendChild(innerWrapper);

                // Append the hidden input and main wrapper to the desired parent element
                const targetContainer = $(".variantsContainer");
                targetContainer.append(hiddenInput);
                targetContainer.append(mainWrapper);
            } else if (option.display && option.type === "button") {
                // Create the hidden input element
                let hiddenInput = document.createElement("input");
                hiddenInput.type = "hidden";
                hiddenInput.name = `properties[${option.heading}]`;
                hiddenInput.className = `${option.name}HiddenInput`;
                hiddenInput.value = option.options[0].value;
                if (option.shape === "circle") {
                    // Replace spaces with underscores in the heading
                    const headingWithHyphen = option.heading.replace(/ /g, "_");

                    // Create the main wrapper div
                    const mainWrapper = document.createElement("div");
                    mainWrapper.className = "selector-wrapper-free-product";

                    // Create the label element
                    const label = document.createElement("label");
                    label.setAttribute("for", `data-variant-option-`);
                    label.setAttribute("data-variant-option-name", option.name);
                    label.setAttribute(
                        "data-variant-option-choose-name",
                        option.name
                    );

                    label.innerHTML = option.heading;

                    // Create the span wrapper
                    const span = document.createElement("span");

                    // Create the buttons
                    option.options.forEach((value, index) => {
                        const button = document.createElement("button");

                        button.type = "button";
                        button.className = `rounded-button ${headingWithHyphen}CircleButtonCustom`;
                        button.setAttribute(
                            "onclick",
                            `changeBorderColor('${option.name}', this, '.rounded-button', '${option.heading}', 'Circle')`
                        );

                        button.innerHTML = value.name;
                        if (index === 0) {
                            button.classList.add("selected"); // Add a class for selected state
                            button.style.border = "2px solid rgb(84, 97, 200)"; // Apply specific style
                        }

                        // Append the button to the span
                        span.appendChild(button);
                    });

                    // Append the label and span to the main wrapper
                    mainWrapper.appendChild(label);
                    mainWrapper.appendChild(span);

                    // Append the main wrapper to the desired parent element
                    const targetContainer = $(".variantsContainer");
                    targetContainer.append(hiddenInput);
                    targetContainer.append(mainWrapper);
                } else if (option.shape === "rectangle") {
                    // Replace spaces with underscores in the heading
                    const headingWithHyphen = option.heading.replace(/ /g, "_");

                    // Create the main wrapper div
                    const mainWrapper = document.createElement("div");
                    mainWrapper.className = "selector-wrapper-free-product";

                    // Create the label element
                    const label = document.createElement("label");
                    label.setAttribute("for", `data-variant-option-`);
                    label.setAttribute("data-variant-option-name", option.name);
                    label.setAttribute(
                        "data-variant-option-choose-name",
                        option.name
                    );

                    label.innerHTML = option.heading;

                    // Create the span wrapper
                    const span = document.createElement("span");

                    // Create the buttons
                    option.options.forEach((value, index) => {
                        const button = document.createElement("button");
                        button.type = "button";
                        button.className = `rectangle-button ${headingWithHyphen}RectangleButtonCustom`;
                        button.setAttribute(
                            "onclick",
                            `changeBorderColor('${option.name}', this, '.rectangle-button', '${option.heading}', 'Rectangle')`
                        );
                        button.innerHTML = value.name;

                        if (index === 0) {
                            button.classList.add("selected"); // Add a class for selected state
                            button.style.border = "2px solid rgb(84, 97, 200)"; // Apply specific style
                        }

                        // Append the button to the span
                        span.appendChild(button);
                    });

                    // Append the label and span to the main wrapper
                    mainWrapper.appendChild(label);
                    mainWrapper.appendChild(span);

                    // Append the main wrapper to the desired parent element
                    const targetContainer = $(".variantsContainer");
                    targetContainer.append(hiddenInput);
                    targetContainer.append(mainWrapper);
                }
            }
        }
    }
}


// ------------Event Listner to validate the bandana field to only accept alphabets
document.addEventListener("DOMContentLoaded", function () {
    // 检测是否需要隐藏Frame Options（当product.type为空且通过customizer跳转时）
    if (isFromPlushClonesCollection()) {
        hideFrameOptions();
    }

    let inputElement = document.querySelector(".bandannaInput");

    inputElement?.addEventListener("input", function (event) {
        let enteredValue = event.target.value;

        // Restrict input to alphabets only and capitalize them
        event.target.value = enteredValue.replace(/[^a-zA-Z]/g, '').toUpperCase();

        // Check if input exceeds 18 characters
        const maxLength = 18;
        if (event.target.value.length > maxLength) {
            alert(`Input cannot exceed ${maxLength} characters.`);
            event.target.value = event.target.value.substring(0, maxLength); // Trim excess characters
        }
    });
});


function checkDisplayTrue(obj) {
    for (let key in obj) {
        if (obj[key].display) {
            return true

        }
    }
    return false;
}

// Function to open the popup
function openPopup() {
    document.getElementById("popup").style.display = "block";
    generateSizeChart(); // Generate size chart tabs and tables
}

// Function to close the popup
function closePopup() {
    document.getElementById("popup").style.display = "none";
}

// Function to dynamically generate tabs and tables
function generateSizeChart() {
    var sizeChartTitle = document.getElementById("sizeChartTitle");
    var sizeChartTabs = document.getElementById("sizeChartTabs");
    var sizeTables = document.getElementById("sizeTables");

    sizeChartTitle.innerHTML = '';
    sizeChartTabs.innerHTML = '';
    sizeTables.innerHTML = '';

    sizeChartTitle.textContent = sizeData.variant_options[0].size_chart.title;


    // Loop through each country in sizeData
    for (var country in sizeData.variant_options[0].size_chart.data) {
        // Generate tab for each country
        var tab = document.createElement('button');
        tab.className = 'tablinks';
        tab.style.fontWeight = 'bold'
        tab.textContent = country;
        tab.onclick = function (countryName) {
            return function () {
                openTab(countryName);
            };
        }(country);
        sizeChartTabs.appendChild(tab);

        // Generate table for size details of each country
        var table = document.createElement('table');
        table.className = 'tabcontent';
        table.id = country;
        var countryData = sizeData.variant_options[0].size_chart.data[country];

        // Create table header row
        var headerRow = table.insertRow();
        var headerCell1 = headerRow.insertCell(0);
        var headerCell2 = headerRow.insertCell(1);
        var headerCell3 = headerRow.insertCell(2);
        headerCell1.textContent = sizeData.variant_options[0].size_chart.key_name;
        headerCell2.textContent = "Female";
        headerCell3.textContent = "Male";
        headerCell1.style.fontWeight = "bold";
        headerCell2.style.fontWeight = "bold";
        headerCell3.style.fontWeight = "bold";
        headerCell1.style.width = "231px";
        headerCell2.style.width = "231px";
        headerCell3.style.width = "231px";

        for (var size in countryData) {
            var row = table.insertRow();
            var cell1 = row.insertCell(0);
            var cell2 = row.insertCell(1);
            var cell3 = row.insertCell(2);
            cell1.textContent = size;
            cell2.textContent = countryData[size].Female;
            cell3.textContent = countryData[size].Male;

        }
        sizeTables.appendChild(table);
    }

    // Show the first tab by default
    var firstTab = sizeChartTabs.querySelector('.tablinks');

    if (firstTab) {
        firstTab.classList.add('active');
        openTab1(firstTab.textContent); // Show corresponding table for the first tab
    }
}

var tabButtons = document.querySelectorAll('.tablinks');
tabButtons.forEach(function (button) {
    button.style.width = (100 / tabButtons.length) + '%'; // Distribute width equally
});

// Function to switch between tabs

function openTab1(tabName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }

    document.getElementById(tabName).style.display = "flex";
    document.getElementById(tabName).style.justifyContent = "center";
    event.currentTarget.classList.add("active");
}

// Function to switch between tabs
function openTab(tabName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].classList.remove("active");
    }
    document.getElementById(tabName).style.display = "flex";
    document.getElementById(tabName).style.justifyContent = "center";
    event.currentTarget.classList.add("active");
}

function isSizeChartAvailable(data) {
    if (data.size === true) {
        return true;
    } else {
        return false;
    }
}

// 用于跟踪IME输入状态
let isComposing = false;

document.getElementById("petname").addEventListener("compositionstart", () => {
    isComposing = true;
});

document.getElementById("petname").addEventListener("compositionend", () => {
    isComposing = false;
    // 在IME输入完成后处理转换和长度检查
    handlePetNameInput();
});

document.getElementById("petname").addEventListener("input", () => {
    // 如果不是IME输入过程，立即处理
    if (!isComposing) {
        handlePetNameInput();
    }
});

function handlePetNameInput() {
    const maxLength = 18;
    const currentValue = petNameInput.value;

    // 保存光标位置
    const cursorPosition = petNameInput.selectionStart;

    // Convert input to uppercase (只对非中文字符)
    const upperCaseValue = currentValue.replace(/[a-z]/g, (match) => match.toUpperCase());

    // 检查长度并截断
    let finalValue = upperCaseValue;
    if (finalValue.length > maxLength) {
        alert(`Pet name cannot exceed ${maxLength} characters.`);
        finalValue = finalValue.substring(0, maxLength);
    }

    // 只有当值真的改变时才更新
    if (petNameInput.value !== finalValue) {
        petNameInput.value = finalValue;
        // 恢复光标位置
        const newCursorPosition = Math.min(cursorPosition, finalValue.length);
        petNameInput.setSelectionRange(newCursorPosition, newCursorPosition);
    }
}


// for keyboard events


function handlePetImageKeydown(event) {
    const currentIndex = petImages.indexOf(event.currentTarget);
    const divStep2 = document.querySelector('.step-2');

    if (event.key === "Enter") {
        event.preventDefault();
        petImages[currentIndex].click();
    }

    if (event.key === "ArrowRight" && currentIndex < petImages.length - 1) {
        petImages[currentIndex + 1].focus();
    }

    if (event.key === "ArrowLeft" && currentIndex > 0) {
        petImages[currentIndex - 1].focus();
    }
}


function clickImageINput(event) {
    const fileInputFunction = document.querySelector(".imageUploader");
    if (event.key === 'Enter') {
        fileInputFunction.click();
    }
}

function eyeColorKeydown(event) {
    const checkbox = document.getElementById("different-eye-color");
    let containers;

    if (checkbox.checked) {
        containers = document.querySelectorAll('#first-palette .color, #second-palette .color');
    } else {
        containers = document.querySelectorAll('#first-palette .color');
    }

    const eyeColors = Array.from(containers);
    const currentIndex = eyeColors.indexOf(event.currentTarget);

    if (event.key === "Enter") {
        event.preventDefault();
        eyeColors[currentIndex].click();
    }

    if (event.key === "ArrowRight" && currentIndex < eyeColors.length - 1) {
        eyeColors[currentIndex + 1].focus();
    }

    if (event.key === "ArrowLeft" && currentIndex > 0) {
        eyeColors[currentIndex - 1].focus();
    }
}


function handlePetPositionKeydown(event) {
    const bodyPosition = Array.from(document.querySelectorAll('.final-product-positions img'));
    const currentIndex = bodyPosition.indexOf(event.currentTarget);

    if (event.key === "Enter") {
        event.preventDefault();
        bodyPosition[currentIndex].click();

    }


}

function handlePetEarKeyDown(event) {
    const EarPosition = Array.from(document.querySelectorAll('.ear-label img'));
    const currentIndex = EarPosition.indexOf(event.currentTarget);

    if (event.key === "Enter") {
        event.preventDefault();
        EarPosition[currentIndex].click();

    }

}

function handleImagesDiv(event) {
    if (event.key === "Delete") {
        event.preventDefault();

        const img = event.currentTarget;
        const imageContainer = img.closest('.image-container');
        const deleteButton = imageContainer?.querySelector('.delete-button');

        if (deleteButton) {
            deleteButton.click();
        }
    }

}

function handleQuestionImages(event) {
    if (event.key === "Enter") {
        event.preventDefault();

        const image = event.currentTarget;
        const label = image.closest("label");

        if (label) {
            const radioInput = label.querySelector('input[type="radio"]');
            if (radioInput) {
                radioInput.click();
            }
        }
    }
}

function handle_DescriptionBox_textarea(event) {
    if (event.key === "Enter") {
        const textarea = Array.from(document.querySelectorAll('.DescriptionBox_Container .DescriptionBox'));
        const currentIndex = textarea.indexOf(event.currentTarget);
        event.preventDefault();
        textarea[currentIndex].click();
    }

}

function handle_EarToggle_Keydown(event) {
    if (event.key === "Enter") {
        event.preventDefault();
        event.currentTarget.click();
    }
}

function rushCreationToggle_Keydown(event) {
    if (event.key === "Enter") {
        event.preventDefault();
        event.currentTarget.click();
    }
}

function EyeColor_ToggleSwitch(event) {
    if (event.key === "Enter") {
        event.preventDefault();
        event.currentTarget.click();
    }

}

function addOnSection_Keydwon(event) {
    if (event.key === "Enter") {
        event.preventDefault();
        event.currentTarget.click();
    }

}


function handleFrameKeyDown(event) {
    const portrait = Array.from(document.querySelectorAll('.frame-image-container img'));
    const currentIndex = portrait.indexOf(event.currentTarget);
    if (event.key === "Enter") {
        event.preventDefault();
        portrait[currentIndex].click();
    }
}

function handleFrame_BGkeydown(event) {
    const background = Array.from(document.querySelectorAll('.background-options-container img'));
    const currentIndex = background.indexOf(event.currentTarget);

    if (event.key === "Enter") {
        event.preventDefault();
        background[currentIndex].click();
    }

}

let isPopupOpen = false;

function handleSizeChartKeyDown(event) {
    if (event.key === "Enter") {
        event.preventDefault();
        if (isPopupOpen) {
            closePopup();
            isPopupOpen = false;
        } else {
            openPopup();
            isPopupOpen = true;
        }
    }
}

// For EyeColor-Pallete Tabs
function openPalette(evt, paletteId) {
    const tabcontent = document.getElementsByClassName("Palettecontent");
    for (let i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }

    const Palettetablinks = document.getElementsByClassName("tablinks-ColorPalette");
    for (let i = 0; i < Palettetablinks.length; i++) {
        Palettetablinks[i].className = Palettetablinks[i].className.replace(" active", "");
    }

    document.getElementById(paletteId).style.display = "flex";
    evt.currentTarget.className += " active";
}

//For EarPosition tabs

function openEarTab(evt, tabId) {
    const tabcontent = document.getElementsByClassName("ear-tab-content");
    for (let i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }

    const tablinks = document.getElementsByClassName("ear-tablink");
    for (let i = 0; i < tablinks.length; i++) {
        tablinks[i].classList.remove("active");
    }

    document.getElementById(tabId).style.display = "flex";
    evt.currentTarget.classList.add("active");
}


function handleEarToggle(checkbox) {
    const earTabs = document.querySelector('.ear-tabs');
    const earleftcol = document.querySelector('#left-col');
    const earrightcol = document.querySelector('#right-col');
    const leftEarInput = document.getElementById("left-ear-position");
    const rightEarInput = document.getElementById("right-ear-position");

    const leftEar = leftEarInput.value;

    if (checkbox.checked) {
        earTabs.style.display = "flex"
        // When ON: user must pick right & left manually, so clear right
        rightEarInput.value = '';

    } else {
        // When OFF: force right to match left if left has value
        earTabs.style.display = "none"
        earleftcol.style.display = "flex"
        earrightcol.style.display = "none"

        if (leftEar) {
            rightEarInput.value = leftEar;
            const rightEarRadios = document.querySelectorAll('input[name="properties[_pet_right_ear]"]');
            rightEarRadios.forEach(input => {
                input.checked = (input.value === leftEar);
            });
        }
    }
}


function setEarPosition(earSide, value) {
    const toggle = document.getElementById("different-ear-position");

    // Find and check the selected radio input for the side
    const earInputs = document.querySelectorAll(`input[name="properties[_pet_${earSide}_ear]"]`);
    earInputs.forEach(input => {
        if (input.value === value) {
            input.checked = true;
        }
    });

    // If toggle is OFF, force both sides to match
    if (!toggle.checked) {
        const otherSide = earSide === 'left' ? 'right' : 'left';
        const otherEarInputs = document.querySelectorAll(`input[name="properties[_pet_${otherSide}_ear]"]`);
        otherEarInputs.forEach(input => {
            if (input.value === value) {
                input.checked = true;
            }
        });
    }
}

function EyeColorValidate_Other(e) {
    e.preventDefault();

    const leftEyeColorInput = document.getElementById('left-eye-color');
    const rightEyeColorInput = document.getElementById('right-eye-color');

    const leftEyeColor = leftEyeColorInput.value.trim();
    const rightEyeColor = rightEyeColorInput.value.trim();

    const eyeColorsSelected = leftEyeColor !== '' && rightEyeColor !== '';

    if (!eyeColorsSelected) {
        alert("Please select eye colors for both eyes.");
        return;
    }

    if (productOptionDisplay) {
        if (rushSection) {
            rushSection.classList.remove('disabled');
            rushSection.scrollIntoView({ behavior: 'smooth' });
        } else {
            step6.classList.remove('disabled');
            step6.scrollIntoView({ behavior: 'smooth' });

        }
    } else {
        if (rushSection) {
            rushSection.classList.remove('disabled');
            rushSection.scrollIntoView({ behavior: 'smooth' });
        } else {
            step6.classList.remove('disabled');
            step6.scrollIntoView({ behavior: 'smooth' });
        }
    }
}


const imageDetailsButton = document.querySelector('.imageDetailsButton button');
if (imageDetailsButton) {
    imageDetailsButton.addEventListener('click', function (event) {
        event.preventDefault();
        const imageDetailContainer = document.querySelector(".image-details-sections");


        //reset the hidden inputs
        document.querySelectorAll("#image-links input").forEach(input => {
            const dataID = input.dataset.id;
            input.name = `properties[${dataID}]`
        })


        // Get selected radios
        const selectedRadios = [
            document.querySelector('input[name="colorImagesCheckbox"]:checked'),
            document.querySelector('input[name="lengthImagesCheckbox"]:checked'),
            document.querySelector('input[name="ageImagesCheckbox"]:checked')
        ];

        for (const radio of selectedRadios) {
            if (!radio) {
                alert("Please select an image for all questions before proceeding.");
                imageDetailContainer.scrollIntoView({ behavior: 'smooth' });
                return;
            }
        }

        const grouped = {};

        selectedRadios.forEach(radio => {
            const questionName = radio.dataset.questionname
            const originalId = radio.dataset.originalid

            if (!grouped[originalId]) {
                grouped[originalId] = [];
            }
            grouped[originalId].push(questionName);
        });

        Object.entries(grouped).forEach(([originalId, questionNames]) => {
            const input = document.querySelector(`#image-links input[data-id="${originalId}"]`);
            if (input) {
                input.name = `properties[${questionNames.join("&")}]`;
            }
        });

        // Enable steps
        step4.classList.remove('disabled');
        step4.scrollIntoView({ behavior: 'smooth' });
        step5.classList.remove('disabled');

    });
}

document.querySelectorAll('.rush-toggle input[type="radio"]').forEach(radio => {
    radio.addEventListener('change', function () {
        const container = this.closest('.main_content_rush_container');
        if (container) {
            // animation reset trick
            container.classList.remove('animate-zoom');
            void container.offsetWidth;
            container.classList.add('animate-zoom');
        }
    });
});

function selectPlushFrameOptions(label, class_name, event, value) {
    removeSelectedClassFromChildren(event);

    event.classList.add("selected");
    event.style.border = "5px solid rgb(215, 69, 164)";
    var getHiddenFields = document.getElementsByClassName(class_name);
    if (event.className.includes("frame")) {
        document.getElementById("formId").value = value;
        getHiddenFields[0].value = label;
    } else {
        getHiddenFields[0].value = label;
    }
}

function removeSelectedClassFromChildren(event) {
    const className = event.className;
    const selectedOption = document.querySelectorAll(`.${className}.selected`);

    if (selectedOption.length > 0) {
        selectedOption.forEach(child => {
            child.classList.remove("selected");
            child.style.border = '';
        });
    }
}